/**
 * Landing 文案（对照桌面 horse landing pages / index 设计）
 */

export const content = {
  // ——— 品牌 ———
  brand: '精英赛马',
  tagline: '从草原到链上，让每一匹马都拥有数字灵魂',

  // ——— Header ———
  logoAlt: 'Horse RWA Trading Platform',
  nav: [
    { label: 'RWA Marketplace', href: '#marketplace' },
    { label: 'Why Equine RWA', href: '#why' },
  ],
  navItems: [
    { label: '首页', href: '#' },
    { label: '马匹市场', href: '#' },
    { label: '关于我们', href: '#why-rwa' },
    { label: '运作方式', href: '#how-it-works' },
    { label: '联系我们', href: '#cta-section' },
  ],
  ctaButton: '进入dapp',

  // ——— Hero（新设计 拥有冠军 / 从一个代币开始）———
  hero: {
    titleLine1: '全球赛马资产数字化',
    titleLine2: 'RWA共同马主平台',
    subtitle: '让每个人都能成为"马主"',
    stats: [
      { number: '2847', label: 'NFT 藏品' },
      { number: '12.5', label: '百万交易额' },
      { number: '1847', label: '活跃会员' },
    ],
    ctaButtons: [
      { label: '我是 马主/共同马主', href: '#' },
      { label: '我是 马商/合作方', href: '#' },
    ],
    ctaBrowse: '浏览赛马',
    ctaLearn: '提交马匹',
  },
  heroNew: {
    titleLine1: '拥有冠军',
    titleLine2: '从一个代币开始',
    subtitle: '全球首个赛马资产数字化平台 · 透明 · 合规 · 共赢',
    ctaBrowse: '浏览赛马',
    ctaLearn: '提交马匹',
  },
  statsNew: [
    { target: 125000000, label: '平台总资产 (USD)' },
    { target: 348, label: '优质赛马' },
    { target: 892000, label: '本月分红 (USD)' },
    { target: 15600, label: '全球会员' },
  ],
  howItWorksNew: {
    title: '三步成为马主',
    subtitle: '简单、透明、安全的投资流程',
    steps: [
      { number: '01', title: '选择赛马', desc: '浏览我们精选的赛马资产，查看血统、战绩和健康档案' },
      { number: '02', title: '购买份额', desc: '通过加密钱包或法币完成购买，持有链上所有权凭证' },
      { number: '03', title: '获得收益', desc: '赛马获胜或资产增值时，自动获得按份额分配的收益' },
    ],
  },
  featuredHorsesTitle: '精选赛马',
  featuredHorsesSubtitle: '投资优质赛马资产，分享冠军荣耀',
  contactMapPlaceholder: '地图位置 - 新加坡总部',
  viewDetail: '查看详情',
  viewAllHorses: '查看全部赛马',
  championBloodline: '冠军血统',
  hot: '热门',
  newListing: '新上市',
  winRate: '胜率',
  record: '战绩',
  soldShare: '已售份额',
  pricePerShare: '单份价格',
  whyRwaSubtitle: '重新定义资产所有权',
  trustSubtitle: '透明合规的法律架构',
  testimonialsTitle: '参与者故事',
  testimonialsSubtitle: '真实参与体验分享',
  testimonialsAnnualized: '年化',
  testimonialsList: [
    { text: '作为科技从业者，我一直对区块链和真实资产感兴趣。Equine RWA 让我以可负担的方式参与赛马投资。我的 Thunder Strike 份额在首次获胜后就获得了分红！', name: '张明', title: '软件工程师 · 3 马份', returnPct: '+24%' },
    { text: '我从小就喜欢马，但从没想过能成为马主。通过这个平台我购买了 Golden Legacy 的份额——现在可以实时观看训练和比赛。太棒了！', name: '李欣怡', title: '市场总监 · 2 马份', returnPct: '+18%' },
    { text: '我参与赛马行业多年，但传统马主模式往往资金门槛高、透明度不足。Equine RWA 提供了更清晰的参与结构。我能持续跟进马匹表现更新，同时运营决策由专业团队负责，这让我很放心。', name: '陈伟', title: '马业爱好者 · 4 马份', returnPct: '+24%', tagline: '按赛事表现参与' },
    { text: '吸引我的是 Equine RWA 的结构而非回报。平台让我理解了共同所有权如何运作，无需亲自管理训练、物流或日常运营。这是一种更有纪律的参与方式。', name: 'David Lee', title: '私人投资者 · 2 马份', returnPct: '+18%', tagline: '长期参与' },
    { text: '作为长期关注纯血赛马的爱好者，我重视透明度。通过 Equine RWA，我可以在一个地方追踪所有权详情、赛事参与和资产更新。这不是投机，而是有依据的参与。', name: 'Sophia Tan', title: '家族办公室 · 5 马份', returnPct: '+22%', tagline: '基于资产的参与' },
  ],
  partnersTitle: '合作生态与专业机构',
  partnersSubtitle: '与顶级机构携手打造可信平台',
  partnersList: [
    { icon: 'fa-university', name: '全球马业联盟' },
    { icon: 'fa-shield-alt', name: '国际保险' },
    { icon: 'fa-briefcase', name: '区块链托管' },
    { icon: 'fa-gavel', name: '律师事务所' },
    { icon: 'fa-hospital', name: '兽医认证' },
    { icon: 'fa-newspaper', name: '马业媒体' },
  ],
  faqTitle: '常见问题',
  faqSubtitle: '解答您关心的问题',
  faqItems: [
    { q: '什么是 Equine RWA？', a: 'Equine RWA 是一个将真实赛马资产代币化的平台。通过区块链技术，我们将赛马的经济权益分割成可交易的数字代币，让更多人能够以较低门槛参与赛马投资。每个代币都有真实赛马资产背书，包括完整的血统、健康和保险记录。' },
    { q: '我需要多少资金才能开始？', a: '起投金额根据不同马匹而异，通常单份从 $1,000 到 $5,000 美元不等。您可以根据自己的预算选择合适的投资标的。平台支持加密货币和法币支付。' },
    { q: '收益如何计算和分配？', a: '收益来源于赛马的比赛奖金、配种费用和资产增值。所有收益根据您持有的份额比例自动分配到您的钱包。分配完全透明，可在区块链上验证。我们不承诺固定回报，所有收益基于实际表现。' },
    { q: '我的投资有哪些风险？', a: '主要风险包括：1) 赛马表现风险（可能输掉比赛）；2) 健康风险（马匹可能受伤，但有保险覆盖）；3) 流动性风险（二级市场交易可能有限）；4) 监管风险（不同地区法规可能变化）。我们建议仔细阅读风险披露文档并进行分散投资。' },
    { q: '如何保证平台的合规性和安全性？', a: '我们与顶级律师事务所合作，建立了清晰的法律架构（SPV/信托结构）。所有马匹由持牌机构托管，拥有完整的兽医记录和保险。平台经过独立审计，所有交易记录在区块链上公开透明。我们遵守各地监管要求，并要求用户完成KYC认证。' },
    { q: '我可以卖出我的份额吗？', a: '是的，您可以在我们的二级市场上出售您的份额。不过，流动性可能因马匹的热度和表现而异。我们正在与第三方交易所合作，以提高代币的流动性。' },
  ],
  ctaNew: {
    title: '准备好成为马主了吗？',
    subtitle: '探索精选赛马，开启您的投资之旅',
    primary: '进入dapp',
    secondary: '联系我们',
  },
  footerPlatformTitle: '平台',
  footerResourcesTitle: '资源',
  footerContactTitle: '联系我们',

  // ——— Why Equine RWA（6 跳，中英版）———
  whyEquineRwa: {
    titleEn: 'Why Equine RWA Redefines Asset Ownership',
    title: '为何 Equine RWA 重新定义资产所有权',
    summary: 'Equine RWA 在不牺牲资产真实性、治理结构与风险认知的前提下，连接现实资产与链上透明性。',
    blocks: [
      {
        index: 1,
        titleCn: '真实资产支撑',
        subtitleCn: '不是概念',
        bodyCn: '每个资产支持型代币代表一匹经过认证并投保赛马的份额化经济权益，具备完整血统、马房位置与兽医记录。无合成资产 · 无虚拟敞口。',
        questionLine: '',
        highlight: false,
      },
      {
        index: 2,
        titleCn: '可验证、可追溯的所有权',
        subtitleCn: '可验证、可追溯',
        bodyCn: '所有权记录、交易与资产更新均可验证、可追溯。代币化提供不可篡改的经济参与证明，而非模糊资产本体。',
        questionLine: '「钱去哪了？」「是不是黑箱？」',
        highlight: false,
      },
      {
        index: 3,
        titleCn: '基于表现，而非承诺收益',
        subtitleCn: '非常关键',
        bodyCn: 'Equine RWA 不承诺固定收益或保证回报。所有结果基于真实赛事表现、资产出售与实际运营。无杠杆 · 无合成收益 · 无金融包装。',
        questionLine: '「是不是骗局？」「是不是高收益套路？」',
        highlight: true,
      },
      {
        index: 4,
        titleCn: '机构级资产结构',
        subtitleCn: '不是散户玩法',
        bodyCn: '每匹赛马均采用清晰的法律所有权、托管安排与运营责任结构。代币化代表经济参与，而非失控的资产转移。',
        questionLine: '「有没有法律结构？」「能不能被机构接受？」',
        highlight: false,
      },
      {
        index: 5,
        titleCn: '历史资产类别的现代化参与方式',
        subtitleCn: '历史资产现代化',
        bodyCn: '纯血赛马作为全球资产类别已存在数百年。Equine RWA 只是现代化参与与确权方式，而非改变资产本质。',
        questionLine: '「这是新骗局吗？」「有没有历史基础？」',
        highlight: false,
      },
      {
        index: 6,
        titleCn: '流动性，而不失去控制权',
        subtitleCn: '给马主与合作方',
        bodyCn: '马主保留运营、训练与马匹福利决策权。Equine RWA 提供的是融资与透明结算，而非干预。',
        questionLine: '「马是不是会被平台控制？」「我是不是会失去主导权？」',
        highlight: false,
      },
    ],
  },

  // ——— 资产可信与结构完整性（10 条，放在 Why Equine RWA 下方）———
  assetIntegrity: {
    title: '资产可信与结构完整性',
    items: [
      { title: '真实资产支撑', body: '所有代币均基于真实存在的赛马资产，不涉及任何合成资产或虚拟敞口。' },
      { title: '份额化经济权益', body: '代币代表对单匹赛马的比例化经济权益，而非整匹马的法律所有权。' },
      { title: '清晰法律结构', body: '每匹赛马均配置明确的法律所有权、SPV / 信托或等效结构，权责边界清晰。' },
      { title: '机构级托管安排', body: '资产由合规托管方或指定主体持有，避免个人控制或混合托管风险。' },
      { title: '链上可验证记录', body: '所有权记录、关键交易与资产状态更新均可追溯、可验证，不可篡改。' },
      { title: '医疗与保险保障', body: '赛马具备完整的兽医记录、健康管理体系及相应保险文件。' },
      { title: '基于表现的收益逻辑', body: '所有分配基于真实赛事表现、资产出售或运营结果，不承诺固定收益。' },
      { title: '透明收入与分配规则', body: '奖金及资产相关收入按照预先定义的规则进行结算与分配。' },
      { title: '运营与治理边界明确', body: '训练、运营与管理职责清晰划分，避免单方随意决策或权责不对等。' },
      { title: '风险充分披露', body: '明确披露赛事风险、流动性风险、运营风险及监管不确定性。' },
    ],
  },

  // ——— 透明法律架构（四步流程图 + 说明，中文版）———
  legalArchitecture: {
    title: '透明法律架构',
    titleEn: 'Transparent Legal Architecture',
    steps: [
      { title: '实物资产', subtitle: '（赛马）' },
      {
        title: '法律实体',
        subtitle: '（SPV/信托）',
        points: ['明确所有权', '托管协议', '运营规则'],
      },
      {
        title: '区块链层',
        subtitle: '（代币化）',
        points: ['ERC-20/1155 代币', '不可篡改记录', '智能合约'],
      },
      {
        title: '投资者',
        subtitle: '（代币持有者）',
        points: ['份额化权益', '分配权', '治理'],
      },
    ],
    paragraphEn: '',
    paragraphZh: [
      '每匹赛马由专门法律实体持有(SPV/信托)。该实体拥有实物资产并定义代币持有者的权利。',
      '代币代表部分受益所有权及基于表现的分配权。法律文件规范运营、托管及收益流向。',
    ],
  },

  // ——— How to Get Started / 如何开始（五步引导）———
  howToGetStarted: {
    title: 'How to Get Started',
    titleZh: '如何开始',
    steps: [
      {
        title: 'Sign Up & Verify',
        titleZh: '创建账户并完成身份验证 (KYC) — 确保平台安全和合规',
        desc: 'Create your account and complete identity verification (KYC). This ensures platform security and regulatory compliance.',
      },
      {
        title: 'Browse Assets',
        titleZh: '浏览可用马匹——查看血统、表现历史、健康状态和所有权详情',
        desc: 'Explore available horses. Review pedigree, performance history, health status, and ownership details. Each asset is fully documented.',
      },
      {
        title: 'Purchase Shares',
        titleZh: '选择您希望拥有的马匹和份额数量——通过加密钱包或法币支付完成购买',
        desc: 'Select the horse and number of shares you wish to own. Complete purchase via crypto wallet or fiat payment (where available).',
      },
      {
        title: 'Own & Track',
        titleZh: '您的所有权在链上确认——访问仪表板实时追踪训练更新、比赛日程和表现指标',
        desc: 'Your ownership is confirmed on-chain. Access your dashboard to track training updates, race schedules, and performance metrics in real time.',
      },
      {
        title: 'Receive Distributions',
        titleZh: '当您的马匹获得奖金或参与流动性事件时，分配自动按您的份额比例流向您的钱包',
        desc: 'When your horse earns winnings or participates in a liquidity event, distributions flow automatically to your wallet, proportional to your share.',
      },
    ],
  },

  // ——— NFT 市场 ———
  marketplace: {
    titleHighlight: 'HORSE',
    titleRest: 'Equine RWA NFT marketplace',
    subtitle: '精选顶级数字赛马收藏',
    statLabels: { speed: '速度', stamina: '耐力', power: '力量' },
    rarityFilter: [
      { value: 'all', label: '全部稀有度' },
      { value: 'legendary', label: '传奇' },
      { value: 'epic', label: '史诗' },
      { value: 'rare', label: '稀有' },
      { value: 'common', label: '普通' },
    ],
    sortFilter: [
      { value: 'price-low', label: '价格：低到高' },
      { value: 'price-high', label: '价格：高到低' },
      { value: 'rarity', label: '稀有度' },
    ],
    buyButton: '立即购买',
  },
  // NFT 卡片数据（展示 4 匹，按价格低到高取前 4）
  nftData: [
    { id: 'EH-001', name: '午夜日蚀', rarity: 'legendary', speed: 98, stamina: 95, power: 92, price: 15.5 },
    { id: 'EH-002', name: '金色雷霆', rarity: 'legendary', speed: 96, stamina: 94, power: 90, price: 14.2 },
    { id: 'EH-003', name: '银色风暴', rarity: 'epic', speed: 92, stamina: 88, power: 89, price: 8.7 },
    { id: 'EH-004', name: '皇家幻影', rarity: 'epic', speed: 90, stamina: 87, power: 85, price: 7.9 },
    { id: 'EH-005', name: '钻石奔腾', rarity: 'epic', speed: 88, stamina: 86, power: 84, price: 7.1 },
    { id: 'EH-006', name: '水晶之风', rarity: 'rare', speed: 85, stamina: 82, power: 80, price: 4.5 },
    { id: 'EH-007', name: '高贵精神', rarity: 'rare', speed: 83, stamina: 80, power: 78, price: 3.9 },
    { id: 'EH-008', name: '迅捷传承', rarity: 'rare', speed: 81, stamina: 79, power: 76, price: 3.2 },
  ] as const,

  // ——— RWA 交易所 ———
  exchange: {
    title: 'RWA 交易所',
    subtitle: '交易真实世界资产代币',
  },

  // ——— Footer（与参考图一致：四列 + 免责声明）———
  footer: {
    brand: 'EQUINE RWA',
    tagline: 'Bringing transparency and access to racehorse ownership through blockchain technology.',
    taglineZh: '从草原到链上，让每一匹马都拥有数字灵魂',
    description: '全球首个赛马资产数字化平台，让每个人都能拥有冠军赛马。',
    socialTitle: 'Social Media',
    copyright: '© 2026 Equine RWA. All rights reserved.',
    quickLinks: [
      { label: 'Home', href: '#' },
      { label: 'Investors', href: '#investors' },
      { label: 'Participants', href: '#participants' },
      { label: 'Partners', href: '#partners' },
      { label: 'FAQ', href: '#faq' },
      { label: 'Legal Documentation', href: '#legal' },
      { label: 'Privacy Policy', href: '#privacy' },
    ],
    contact: [
      { label: 'hello@equinerwa.com', href: 'mailto:hello@equinerwa.com' },
      { label: 'support@equinerwa.com', href: 'mailto:support@equinerwa.com' },
      { label: 'partners@equinerwa.com', href: 'mailto:partners@equinerwa.com' },
    ],
    social: [
      { label: 'Telegram', href: '#', icon: 'telegram' },
      { label: 'X (Twitter)', href: '#', icon: 'x' },
      { label: 'LinkedIn', href: '#', icon: 'linkedin' },
      { label: 'Medium', href: '#', icon: 'medium' },
    ],
    riskDisclaimerEn: '',
    riskDisclaimerZh:
      '风险免责说明：参与 Equine RWA 涉及真实世界资产相关特性。任何回报（如有）均基于实际赛事表现及资产运营结果，且不构成固定或保证收益。赛马作为真实资产，其表现可能受到多种因素影响。资产相关权益的流动性取决于平台机制及市场条件，可能不具备即时退出特性。',
  },

  // ——— About 页面 ———
  aboutTitle: '关于 Equine RWA',
  aboutSubtitle: '重新定义赛马资产所有权，让每个人都能拥有冠军',
  aboutMissionTitle: '我们的使命',
  aboutMissionSubtitle: '打造透明、公平、可信的赛马资产数字化平台',
  aboutMissionP1:
    'Equine RWA 通过区块链技术将传统赛马资产数字化，让全球投资者能够以较低门槛参与这个历史悠久的资产类别。我们致力于提供真实资产背书、透明运营和基于实际表现的收益分配机制。',
  aboutMissionP2:
    '我们相信，通过现代科技与传统马业的结合，可以创造出一个更加开放、透明和公平的投资环境，让每个热爱赛马的人都能成为马主。',
  aboutValuesTitle: '核心价值观',
  aboutValues: [
    { icon: 'fa-shield-alt', title: '透明诚信', desc: '所有交易和资产信息在区块链上公开透明，可追溯可验证，确保投资者权益。' },
    { icon: 'fa-balance-scale', title: '合规运营', desc: '严格遵守各地监管要求，建立完善的法律架构和托管机制。' },
    { icon: 'fa-users', title: '用户至上', desc: '始终将用户体验和权益放在首位，提供专业的服务和支持。' },
    { icon: 'fa-lightbulb', title: '持续创新', desc: '不断探索区块链与实物资产结合的新模式，引领行业发展。' },
  ],
  aboutTeamTitle: '专业团队',
  aboutTeamSubtitle: '融合马业专家与区块链技术人才',
  aboutTeamCards: [
    { icon: 'fa-user-tie', title: '马业专家团队', desc: '30年以上赛马行业经验' },
    { icon: 'fa-laptop-code', title: '技术开发团队', desc: '顶尖区块链开发专家' },
    { icon: 'fa-gavel', title: '法律合规团队', desc: '资深金融法律顾问' },
    { icon: 'fa-headset', title: '客户服务团队', desc: '7x24小时专业支持' },
  ],
  aboutCtaTitle: '加入 Equine RWA 社区',
  aboutCtaSubtitle: '与全球马主一起，见证冠军的诞生',

  // ——— Contact 页面 ———
  contactTitle: '联系我们',
  contactSubtitle: '我们随时为您解答疑问，欢迎咨询',
  contactInfoTitle: '联系方式',
  contactFormTitle: '发送消息',
  contactFormDesc: '填写下方表单，我们将在24小时内回复您',
  contactItems: [
    { icon: 'fa-envelope', title: '邮箱', content: 'support@equinerwa.com\nbusiness@equinerwa.com' },
    { icon: 'fa-map-marker-alt', title: '地址', content: '2 Orchard Turn, #05-03 ION Orchard\nSingapore 238801' },
    { icon: 'fa-comments', title: '社交媒体', social: true },
  ],
  contactSubjectOptions: [
    { value: '', label: '请选择咨询主题' },
    { value: 'general', label: '一般咨询' },
    { value: 'investment', label: '投资相关' },
    { value: 'technical', label: '技术支持' },
    { value: 'partnership', label: '合作洽谈' },
    { value: 'media', label: '媒体采访' },
    { value: 'other', label: '其他' },
  ],
  contactThankYou: '感谢您的消息！我们将在24小时内回复您。',
  contactName: '姓名',
  contactNamePlaceholder: '请输入您的姓名',
  contactEmail: '邮箱',
  contactSubject: '主题',
  contactMessage: '消息内容',
  contactMessagePlaceholder: '请详细描述您的问题或需求...',
  contactSend: '发送消息',

  // ——— Marketplace 页面 ———
  marketplacePageTitle: '马匹市场',
  marketplacePageSubtitle: '发现优质赛马资产，开启您的投资之旅',
  breadcrumbHome: '首页',
} as const

export type Locale = 'zh' | 'ko' | 'en' | 'ja' | 'vi'

const heroEn = {
  titleLine1: 'Global Racehorse Asset Digitalization',
  titleLine2: 'Shared Horse Owner Platform',
  subtitle: 'Let everyone become a "Horse Owner"',
}
const heroJa = {
  titleLine1: '世界の競馬資産のデジタル化',
  titleLine2: '共有馬主プラットフォーム',
  subtitle: '誰もが「馬主」になれるように',
}
const heroKo = {
  titleLine1: '전세계 경마 자산 디지털화',
  titleLine2: 'RWA 공동 마주 플랫폼',
  subtitle: '모두가 「마주」가 될 수 있도록',
  stats: [
    { number: '2847', label: 'NFT 컬렉션' },
    { number: '12.5', label: '백만 거래액' },
    { number: '1847', label: '활성 회원' },
  ],
}

const heroVi = {
  titleLine1: 'Số hóa tài sản ngựa đua toàn cầu',
  titleLine2: 'Nền tảng chủ sở hữu ngựa chia sẻ',
  subtitle: 'Để mọi người đều có thể trở thành "Chủ ngựa"',
  stats: [
    { number: '2847', label: 'Bộ sưu tập NFT' },
    { number: '12.5', label: 'Triệu giao dịch' },
    { number: '1847', label: 'Thành viên hoạt động' },
  ],
}

const blocksEn = [
  { index: 1, titleCn: 'Real Asset Backing', subtitleCn: '', bodyCn: 'Each asset-backed token represents fractional economic interest in a certified, insured racehorse, with full pedigree, stable location and veterinary records. No synthetic assets · No virtual exposure.', questionLine: '', highlight: false },
  { index: 2, titleCn: 'Verifiable, Traceable Ownership', subtitleCn: '', bodyCn: 'Ownership records, transactions and asset updates are verifiable and traceable. Tokenization provides tamper-proof proof of economic participation, not vague asset identity.', questionLine: '', highlight: false },
  { index: 3, titleCn: 'Performance-Based, Not Promised Returns', subtitleCn: '', bodyCn: 'Equine RWA does not promise fixed returns or guaranteed payouts. All outcomes are based on actual race performance, asset sales and operations. No leverage · No synthetic yield · No financial packaging.', questionLine: '', highlight: true },
  { index: 4, titleCn: 'Institutional-Grade Asset Structure', subtitleCn: '', bodyCn: 'Each racehorse has clear legal ownership, custody and operational responsibility. Tokenization represents economic participation, not uncontrolled asset transfer.', questionLine: '', highlight: false },
  { index: 5, titleCn: 'Modern Access to a Historic Asset Class', subtitleCn: '', bodyCn: 'Thoroughbred racehorses have existed as a global asset class for centuries. Equine RWA is a modern way to participate and prove rights, not to change the nature of the asset.', questionLine: '', highlight: false },
  { index: 6, titleCn: 'Liquidity Without Losing Control', subtitleCn: '', bodyCn: 'Horse owners retain operational, training and welfare decisions. Equine RWA provides financing and transparent settlement, not intervention.', questionLine: '', highlight: false },
]

const assetIntegrityItemsEn = [
  { title: 'Real Asset Backing', body: 'All tokens are backed by real racehorse assets, with no synthetic or virtual exposure.' },
  { title: 'Fractional Economic Interest', body: 'Tokens represent proportional economic interest in a single horse, not full legal ownership.' },
  { title: 'Clear Legal Structure', body: 'Each horse has defined legal ownership, SPV/trust or equivalent structure with clear boundaries.' },
  { title: 'Institutional Custody', body: 'Assets are held by compliant custodians or designated entities, avoiding personal control or commingling risk.' },
  { title: 'On-Chain Verifiable Records', body: 'Ownership records, key transactions and asset updates are traceable, verifiable and immutable.' },
  { title: 'Medical & Insurance Coverage', body: 'Horses have complete veterinary records, health management and insurance documentation.' },
  { title: 'Performance-Based Revenue Logic', body: 'All distributions are based on actual race performance, asset sales or operations; no fixed return is promised.' },
  { title: 'Transparent Income & Distribution Rules', body: 'Prize and asset-related income is settled and distributed according to predefined rules.' },
  { title: 'Clear Operational & Governance Boundaries', body: 'Training, operations and management are clearly separated to avoid unilateral decisions or misaligned accountability.' },
  { title: 'Full Risk Disclosure', body: 'Race, liquidity, operational and regulatory risks are clearly disclosed.' },
]

const legalStepsEn = [
  { title: 'Physical Asset', subtitle: '(Racehorse)' },
  { title: 'Legal Entity', subtitle: '(SPV/Trust)', points: ['Clear ownership', 'Custody agreement', 'Operating rules'] },
  { title: 'Blockchain Layer', subtitle: '(Tokenization)', points: ['ERC-20/1155 tokens', 'Immutable records', 'Smart contracts'] },
  { title: 'Investors', subtitle: '(Token holders)', points: ['Fractional interest', 'Distribution rights', 'Governance'] },
]

const legalParagraphEn = [
  'Each racehorse is held by a dedicated legal entity (SPV/Trust). That entity owns the physical asset and defines token holder rights.',
  'Tokens represent fractional beneficial ownership and performance-based distribution rights. Legal documents govern operations, custody and revenue flow.',
]

const howToStepsEn = [
  { title: 'Sign Up & Verify', titleZh: 'Create an account and complete identity verification (KYC) — for platform security and compliance', desc: '', },
  { title: 'Browse Assets', titleZh: 'Browse available horses — view pedigree, performance history, health status and ownership details', desc: '', },
  { title: 'Purchase Shares', titleZh: 'Choose the horse and number of shares you want — complete purchase via crypto wallet or fiat', desc: '', },
  { title: 'Own & Track', titleZh: 'Your ownership is confirmed on-chain — use the dashboard to track training, races and performance', desc: '', },
  { title: 'Receive Distributions', titleZh: 'When your horse wins or participates in liquidity events, distributions flow to your wallet by share', desc: '', },
]

const blocksJa = [
  { index: 1, titleCn: '実物資産の裏付け', subtitleCn: '', bodyCn: '各資産担保トークンは、血統・厩舎・獣医記録を備えた認証・保険付き競走馬の持分経済権益を表します。合成資産なし・仮想エクスポージャーなし。', questionLine: '', highlight: false },
  { index: 2, titleCn: '検証可能・追跡可能な所有権', subtitleCn: '', bodyCn: '所有権記録・取引・資産更新は検証・追跡可能です。トークン化は改ざん不能な経済参加の証明を提供し、曖昧な資産本体ではありません。', questionLine: '', highlight: false },
  { index: 3, titleCn: '実績ベース、約束利回りではない', subtitleCn: '', bodyCn: 'Equine RWA は固定利回りや保証リターンを約束しません。すべての結果は実際の競走成績・資産売却・運営に基づきます。レバレッジなし・合成収益なし・金融包装なし。', questionLine: '', highlight: true },
  { index: 4, titleCn: '機関向け資産構造', subtitleCn: '', bodyCn: '各競走馬は明確な法的所有権・保管・運営責任の構造を採用。トークン化は経済参加を表し、制御不能な資産移転ではありません。', questionLine: '', highlight: false },
  { index: 5, titleCn: '歴史的資産クラスへの現代的な参加', subtitleCn: '', bodyCn: 'サラブレッド競走馬は何世紀もグローバル資産クラスとして存在。Equine RWA は参加と権利確認の現代的手法であり、資産の本質を変えるものではありません。', questionLine: '', highlight: false },
  { index: 6, titleCn: '流動性とコントロールの両立', subtitleCn: '', bodyCn: '馬主は運営・調教・馬の福祉に関する意思決定を維持。Equine RWA は資金調達と透明な決済を提供し、介入ではありません。', questionLine: '', highlight: false },
]

const assetIntegrityItemsJa = [
  { title: '実物資産の裏付け', body: 'すべてのトークンは実在する競走馬資産に裏付けられ、合成・仮想エクスポージャーはありません。' },
  { title: '持分経済権益', body: 'トークンは単一馬への比例的経済権益を表し、馬全体の法的所有権ではありません。' },
  { title: '明確な法務構造', body: '各馬は法的所有権・SPV/信託または同等構造を備え、権限と責任が明確です。' },
  { title: '機関級保管体制', body: '資産はコンプライアンス保管者または指定主体が保有し、個人支配や混合保管リスクを回避。' },
  { title: 'オンチェーン検証可能記録', body: '所有権記録・重要取引・資産状態更新は追跡・検証可能で改ざん不可。' },
  { title: '医療・保険保障', body: '馬は獣医記録・健康管理・保険書類を完備。' },
  { title: '実績ベースの収益ロジック', body: 'すべての分配は実際の競走成績・資産売却・運営に基づき、固定リターンは約束しません。' },
  { title: '透明な収入・分配ルール', body: '賞金および資産関連収入は事前定義ルールに従い決済・分配。' },
  { title: '運営・ガバナンス境界の明確化', body: '調教・運営・管理は明確に分離し、一方的な意思決定や責任の不整合を回避。' },
  { title: 'リスクの十分な開示', body: '競走・流動性・運営・規制リスクを明確に開示。' },
]

const legalStepsJa = [
  { title: '実物資産', subtitle: '（競走馬）' },
  { title: '法的主体', subtitle: '（SPV/信託）', points: ['明確な所有権', '保管契約', '運営規則'] },
  { title: 'ブロックチェーン層', subtitle: '（トークン化）', points: ['ERC-20/1155 トークン', '改ざん不可記録', 'スマートコントラクト'] },
  { title: '投資家', subtitle: '（トークン保有者）', points: ['持分権益', '分配権', 'ガバナンス'] },
]

const legalParagraphJa = [
  '各競走馬は専用の法的主体（SPV/信託）が保有。その主体が実物資産を所有し、トークン保有者の権利を定義します。',
  'トークンは持分的受益所有権および実績ベースの分配権を表します。法文書が運営・保管・収益フローを規定します。',
]

const howToStepsJa = [
  { title: 'Sign Up & Verify', titleZh: 'アカウント作成と本人確認（KYC）完了 — プラットフォームの安全とコンプライアンスのため', desc: '', },
  { title: 'Browse Assets', titleZh: '利用可能な馬を閲覧 — 血統・競走成績・健康状態・所有権詳細を確認', desc: '', },
  { title: 'Purchase Shares', titleZh: '希望する馬と持分数を選択 — 暗号ウォレットまたは法定通貨で購入', desc: '', },
  { title: 'Own & Track', titleZh: '所有権はオンチェーンで確認 — ダッシュボードで調教・レース・成績を追跡', desc: '', },
  { title: 'Receive Distributions', titleZh: '馬が勝利または流動性イベントに参加した際、持分に応じて分配がウォレットに送金', desc: '', },
]

const nftDataEn = [
  { id: 'EH-001', name: 'Midnight Eclipse', rarity: 'legendary', speed: 98, stamina: 95, power: 92, price: 15.5 },
  { id: 'EH-002', name: 'Golden Thunder', rarity: 'legendary', speed: 96, stamina: 94, power: 90, price: 14.2 },
  { id: 'EH-003', name: 'Silver Storm', rarity: 'epic', speed: 92, stamina: 88, power: 89, price: 8.7 },
  { id: 'EH-004', name: 'Royal Phantom', rarity: 'epic', speed: 90, stamina: 87, power: 85, price: 7.9 },
  { id: 'EH-005', name: 'Diamond Gallop', rarity: 'epic', speed: 88, stamina: 86, power: 84, price: 7.1 },
  { id: 'EH-006', name: 'Crystal Wind', rarity: 'rare', speed: 85, stamina: 82, power: 80, price: 4.5 },
  { id: 'EH-007', name: 'Noble Spirit', rarity: 'rare', speed: 83, stamina: 80, power: 78, price: 3.9 },
  { id: 'EH-008', name: 'Swift Legacy', rarity: 'rare', speed: 81, stamina: 79, power: 76, price: 3.2 },
]

const nftDataJa = [
  { id: 'EH-001', name: 'ミッドナイトエクリプス', rarity: 'legendary', speed: 98, stamina: 95, power: 92, price: 15.5 },
  { id: 'EH-002', name: 'ゴールデンサンダー', rarity: 'legendary', speed: 96, stamina: 94, power: 90, price: 14.2 },
  { id: 'EH-003', name: 'シルバーストーム', rarity: 'epic', speed: 92, stamina: 88, power: 89, price: 8.7 },
  { id: 'EH-004', name: 'ロイヤルファントム', rarity: 'epic', speed: 90, stamina: 87, power: 85, price: 7.9 },
  { id: 'EH-005', name: 'ダイヤモンドギャロップ', rarity: 'epic', speed: 88, stamina: 86, power: 84, price: 7.1 },
  { id: 'EH-006', name: 'クリスタルウィンド', rarity: 'rare', speed: 85, stamina: 82, power: 80, price: 4.5 },
  { id: 'EH-007', name: 'ノーブルスピリット', rarity: 'rare', speed: 83, stamina: 80, power: 78, price: 3.9 },
  { id: 'EH-008', name: 'スウィフトレガシー', rarity: 'rare', speed: 81, stamina: 79, power: 76, price: 3.2 },
]

const blocksKo = [
  { index: 1, titleCn: '실물 자산 담보', subtitleCn: '', bodyCn: '각 자산 담보 토큰은 혈통·마방·수의 기록을 갖춘 인증·보험 경주마의 지분 경제적 권익을 나타냅니다. 합성 자산 없음 · 가상 노출 없음.', questionLine: '', highlight: false },
  { index: 2, titleCn: '검증·추적 가능한 소유권', subtitleCn: '', bodyCn: '소유권 기록, 거래 및 자산 업데이트는 검증·추적 가능합니다. 토큰화는 변조 불가능한 경제 참여 증명을 제공하며, 모호한 자산 정체가 아닙니다.', questionLine: '', highlight: false },
  { index: 3, titleCn: '실적 기반, 약속 수익 아님', subtitleCn: '', bodyCn: 'Equine RWA는 고정 수익이나 보장 수익을 약속하지 않습니다. 모든 결과는 실제 경주 성적·자산 매각·운영에 기반합니다. 레버리지 없음 · 합성 수익 없음 · 금융 포장 없음.', questionLine: '', highlight: true },
  { index: 4, titleCn: '기관급 자산 구조', subtitleCn: '', bodyCn: '각 경주마는 명확한 법적 소유권·수탁·운영 책임 구조를 갖춥니다. 토큰화는 경제 참여를 나타내며, 통제 불가 자산 이전이 아닙니다.', questionLine: '', highlight: false },
  { index: 5, titleCn: '역사적 자산 클래스에 대한 현대적 참여', subtitleCn: '', bodyCn: '순혈 경주마는 수세기 동안 글로벌 자산 클래스로 존재해 왔습니다. Equine RWA는 참여와 권리 확인의 현대적 방식이며, 자산의 본질을 바꾸지 않습니다.', questionLine: '', highlight: false },
  { index: 6, titleCn: '유동성과 통제권 유지', subtitleCn: '', bodyCn: '마주는 운영·조련·마복지 결정권을 유지합니다. Equine RWA는 자금 조달과 투명한 결산을 제공하며, 개입이 아닙니다.', questionLine: '', highlight: false },
]

const assetIntegrityItemsKo = [
  { title: '실물 자산 담보', body: '모든 토큰은 실존하는 경주마 자산에 담보되어 있으며, 합성·가상 노출이 없습니다.' },
  { title: '지분 경제적 권익', body: '토큰은 단일 마에 대한 비례적 경제적 권익을 나타내며, 말 전체의 법적 소유권이 아닙니다.' },
  { title: '명확한 법적 구조', body: '각 마는 법적 소유권·SPV/신탁 또는 동등 구조를 갖추며, 권한과 책임이 명확합니다.' },
  { title: '기관급 수탁 체계', body: '자산은 규정 준수 수탁자 또는 지정 주체가 보유하며, 개인 통제 또는 혼합 수탁 위험을 피합니다.' },
  { title: '온체인 검증 가능 기록', body: '소유권 기록·주요 거래·자산 상태 업데이트는 추적·검증 가능하며 변경 불가능합니다.' },
  { title: '의료·보험 보장', body: '말은 수의 기록·건강 관리·보험 서류를 갖춥니다.' },
  { title: '실적 기반 수익 로직', body: '모든 분배는 실제 경주 성적·자산 매각·운영에 기반하며, 고정 수익을 약속하지 않습니다.' },
  { title: '투명한 수입·분배 규칙', body: '상금 및 자산 관련 수입은 사전 정의된 규칙에 따라 결산·분배됩니다.' },
  { title: '운영·거버넌스 경계 명확', body: '조련·운영·관리는 명확히 분리되어 일방적 결정이나 책임 불균형을 피합니다.' },
  { title: '리스크 충분 공시', body: '경주·유동성·운영·규제 리스크를 명확히 공시합니다.' },
]

const legalStepsKo = [
  { title: '실물 자산', subtitle: '(경주마)' },
  { title: '법인', subtitle: '(SPV/신탁)', points: ['명확한 소유권', '수탁 계약', '운영 규칙'] },
  { title: '블록체인 계층', subtitle: '(토큰화)', points: ['ERC-20/1155 토큰', '변경 불가 기록', '스마트 컨트랙트'] },
  { title: '투자자', subtitle: '(토큰 보유자)', points: ['지분 권익', '분배권', '거버넌스'] },
]

const legalParagraphKo = [
  '각 경주마는 전용 법인(SPV/신탁)이 보유합니다. 해당 법인이 실물 자산을 소유하고 토큰 보유자 권리를 정의합니다.',
  '토큰은 지분적 수익 소유권 및 실적 기반 분배권을 나타냅니다. 법적 문서가 운영·수탁·수익 흐름을 규정합니다.',
]

const howToStepsKo = [
  { title: 'Sign Up & Verify', titleZh: '계정 생성 및 신원 확인(KYC) 완료 — 플랫폼 보안 및 규정 준수를 위해', desc: '', },
  { title: 'Browse Assets', titleZh: '이용 가능한 말 둘러보기 — 혈통·경주 성적·건강 상태·소유권 상세 확인', desc: '', },
  { title: 'Purchase Shares', titleZh: '원하는 말과 지분 수 선택 — 암호화폐 지갑 또는 법정화폐로 구매', desc: '', },
  { title: 'Own & Track', titleZh: '소유권은 온체인으로 확인 — 대시보드에서 조련·경주·성적 추적', desc: '', },
  { title: 'Receive Distributions', titleZh: '말이 우승하거나 유동성 이벤트에 참여할 때 지분에 따라 분배가 지갑으로 전달', desc: '', },
]

const nftDataKo = [
  { id: 'EH-001', name: '미드나이트 이클립스', rarity: 'legendary', speed: 98, stamina: 95, power: 92, price: 15.5 },
  { id: 'EH-002', name: '골든 썬더', rarity: 'legendary', speed: 96, stamina: 94, power: 90, price: 14.2 },
  { id: 'EH-003', name: '실버 스톰', rarity: 'epic', speed: 92, stamina: 88, power: 89, price: 8.7 },
  { id: 'EH-004', name: '로열 팬텀', rarity: 'epic', speed: 90, stamina: 87, power: 85, price: 7.9 },
  { id: 'EH-005', name: '다이아몬드 갤럽', rarity: 'epic', speed: 88, stamina: 86, power: 84, price: 7.1 },
  { id: 'EH-006', name: '크리스탈 윈드', rarity: 'rare', speed: 85, stamina: 82, power: 80, price: 4.5 },
  { id: 'EH-007', name: '노블 스피릿', rarity: 'rare', speed: 83, stamina: 80, power: 78, price: 3.9 },
  { id: 'EH-008', name: '스위프트 레거시', rarity: 'rare', speed: 81, stamina: 79, power: 76, price: 3.2 },
]

const blocksVi = [
  { index: 1, titleCn: 'Tài sản thực làm nền tảng', subtitleCn: '', bodyCn: 'Mỗi token được bảo chứng bằng tài sản đại diện cho quyền lợi kinh tế theo tỷ lệ của ngựa đua được chứng nhận và bảo hiểm, có đầy đủ gia phả, vị trí chuồng và hồ sơ thú y. Không tài sản tổng hợp · Không phơi nhiễm ảo.', questionLine: '', highlight: false },
  { index: 2, titleCn: 'Quyền sở hữu có thể xác minh, truy vết', subtitleCn: '', bodyCn: 'Hồ sơ sở hữu, giao dịch và cập nhật tài sản đều có thể xác minh và truy vết. Token hóa cung cấp bằng chứng tham gia kinh tế không thể giả mạo, không phải bản thể tài sản mơ hồ.', questionLine: '', highlight: false },
  { index: 3, titleCn: 'Dựa trên hiệu suất, không hứa lợi nhuận', subtitleCn: '', bodyCn: 'Equine RWA không hứa lợi nhuận cố định hay đảm bảo. Mọi kết quả dựa trên thành tích đua thực tế, bán tài sản và vận hành. Không đòn bẩy · Không lợi nhuận tổng hợp · Không đóng gói tài chính.', questionLine: '', highlight: true },
  { index: 4, titleCn: 'Cấu trúc tài sản cấp tổ chức', subtitleCn: '', bodyCn: 'Mỗi ngựa đua có cấu trúc quyền sở hữu pháp lý, sắp xếp ủy thác và trách nhiệm vận hành rõ ràng. Token hóa đại diện cho sự tham gia kinh tế, không phải chuyển nhượng tài sản mất kiểm soát.', questionLine: '', highlight: false },
  { index: 5, titleCn: 'Cách tham gia hiện đại vào lớp tài sản lịch sử', subtitleCn: '', bodyCn: 'Ngựa thuần chủng đã tồn tại như lớp tài sản toàn cầu hàng thế kỷ. Equine RWA chỉ là cách hiện đại để tham gia và xác lập quyền, không thay đổi bản chất tài sản.', questionLine: '', highlight: false },
  { index: 6, titleCn: 'Thanh khoản mà không mất quyền kiểm soát', subtitleCn: '', bodyCn: 'Chủ ngựa giữ quyền quyết định vận hành, huấn luyện và phúc lợi ngựa. Equine RWA cung cấp tài trợ và thanh toán minh bạch, không can thiệp.', questionLine: '', highlight: false },
]

const assetIntegrityItemsVi = [
  { title: 'Tài sản thực làm nền tảng', body: 'Mọi token đều được bảo chứng bởi tài sản ngựa đua thực, không liên quan tài sản tổng hợp hay phơi nhiễm ảo.' },
  { title: 'Quyền lợi kinh tế theo tỷ lệ', body: 'Token đại diện cho quyền lợi kinh tế theo tỷ lệ với từng con ngựa, không phải quyền sở hữu pháp lý toàn bộ con ngựa.' },
  { title: 'Cấu trúc pháp lý rõ ràng', body: 'Mỗi ngựa có quyền sở hữu pháp lý, SPV/ủy thác hoặc cấu trúc tương đương với ranh giới trách nhiệm rõ ràng.' },
  { title: 'Sắp xếp ủy thác cấp tổ chức', body: 'Tài sản do bên ủy thác tuân thủ hoặc chủ thể được chỉ định nắm giữ, tránh kiểm soát cá nhân hoặc rủi ro ủy thác hỗn hợp.' },
  { title: 'Hồ sơ on-chain có thể xác minh', body: 'Hồ sơ sở hữu, giao dịch quan trọng và cập nhật tài sản đều có thể truy vết, xác minh và bất biến.' },
  { title: 'Bảo hiểm y tế và bảo hiểm', body: 'Ngựa có hồ sơ thú y, quản lý sức khỏe và tài liệu bảo hiểm đầy đủ.' },
  { title: 'Logic thu nhập dựa trên hiệu suất', body: 'Mọi phân phối dựa trên thành tích đua thực tế, bán tài sản hoặc vận hành; không hứa lợi nhuận cố định.' },
  { title: 'Quy tắc thu nhập và phân phối minh bạch', body: 'Tiền thưởng và thu nhập liên quan tài sản được thanh toán và phân phối theo quy tắc định sẵn.' },
  { title: 'Ranh giới vận hành và quản trị rõ ràng', body: 'Huấn luyện, vận hành và quản lý được phân tách rõ ràng để tránh quyết định đơn phương hoặc trách nhiệm không tương xứng.' },
  { title: 'Công bố rủi ro đầy đủ', body: 'Rủi ro đua, thanh khoản, vận hành và quy định được công bố rõ ràng.' },
]

const legalStepsVi = [
  { title: 'Tài sản vật chất', subtitle: '(Ngựa đua)' },
  { title: 'Thực thể pháp lý', subtitle: '(SPV/Ủy thác)', points: ['Quyền sở hữu rõ ràng', 'Thỏa thuận ủy thác', 'Quy tắc vận hành'] },
  { title: 'Lớp blockchain', subtitle: '(Token hóa)', points: ['Token ERC-20/1155', 'Hồ sơ bất biến', 'Hợp đồng thông minh'] },
  { title: 'Nhà đầu tư', subtitle: '(Người nắm giữ token)', points: ['Quyền lợi theo tỷ lệ', 'Quyền phân phối', 'Quản trị'] },
]

const legalParagraphVi = [
  'Mỗi ngựa đua do một thực thể pháp lý chuyên biệt (SPV/Ủy thác) nắm giữ. Thực thể đó sở hữu tài sản vật chất và xác định quyền của người nắm giữ token.',
  'Token đại diện cho quyền sở hữu hưởng lợi theo tỷ lệ và quyền phân phối dựa trên hiệu suất. Tài liệu pháp lý điều chỉnh vận hành, ủy thác và dòng doanh thu.',
]

const howToStepsVi = [
  { title: 'Sign Up & Verify', titleZh: 'Tạo tài khoản và hoàn tất xác minh danh tính (KYC) — đảm bảo an ninh và tuân thủ nền tảng', desc: '', },
  { title: 'Browse Assets', titleZh: 'Duyệt ngựa có sẵn — xem gia phả, lịch sử thành tích, tình trạng sức khỏe và chi tiết sở hữu', desc: '', },
  { title: 'Purchase Shares', titleZh: 'Chọn ngựa và số cổ phần bạn muốn — hoàn tất mua qua ví tiền mã hóa hoặc fiat', desc: '', },
  { title: 'Own & Track', titleZh: 'Quyền sở hữu được xác nhận on-chain — dùng bảng điều khiển theo dõi huấn luyện, đua và hiệu suất', desc: '', },
  { title: 'Receive Distributions', titleZh: 'Khi ngựa của bạn thắng hoặc tham gia sự kiện thanh khoản, phân phối chảy về ví theo tỷ lệ cổ phần', desc: '', },
]

const nftDataVi = [
  { id: 'EH-001', name: 'Nhật Thực Nửa Đêm', rarity: 'legendary', speed: 98, stamina: 95, power: 92, price: 15.5 },
  { id: 'EH-002', name: 'Sấm Vàng', rarity: 'legendary', speed: 96, stamina: 94, power: 90, price: 14.2 },
  { id: 'EH-003', name: 'Bão Bạc', rarity: 'epic', speed: 92, stamina: 88, power: 89, price: 8.7 },
  { id: 'EH-004', name: 'Ảo Ảnh Hoàng Gia', rarity: 'epic', speed: 90, stamina: 87, power: 85, price: 7.9 },
  { id: 'EH-005', name: 'Phi Nước Đại Kim Cương', rarity: 'epic', speed: 88, stamina: 86, power: 84, price: 7.1 },
  { id: 'EH-006', name: 'Gió Pha Lê', rarity: 'rare', speed: 85, stamina: 82, power: 80, price: 4.5 },
  { id: 'EH-007', name: 'Tinh Thần Cao Quý', rarity: 'rare', speed: 83, stamina: 80, power: 78, price: 3.9 },
  { id: 'EH-008', name: 'Di Sản Nhanh Nhẹn', rarity: 'rare', speed: 81, stamina: 79, power: 76, price: 3.2 },
]

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const translations: Record<Exclude<Locale, 'zh'>, any> = {
  en: {
    nav: content.nav,
    navItems: [
      { label: 'Home', href: '#' },
      { label: 'Marketplace', href: '#' },
      { label: 'About', href: '#why-rwa' },
      { label: 'How It Works', href: '#how-it-works' },
      { label: 'Contact', href: '#cta-section' },
    ],
    ctaButton: 'Enter DApp',
    hero: { ...content.hero, ...heroEn },
    heroNew: {
      titleLine1: 'Own Champions',
      titleLine2: 'One Token at a Time',
      subtitle: 'Global equine asset digitization platform · Transparent · Compliant · Win-win',
      ctaBrowse: 'Browse Horses',
      ctaLearn: 'List Your Horse',
    },
    statsNew: [
      { target: 125000000, label: 'Platform Assets (USD)' },
      { target: 348, label: 'Premium Horses' },
      { target: 892000, label: 'Monthly Distributions (USD)' },
      { target: 15600, label: 'Global Members' },
    ],
    howItWorksNew: {
      title: 'Three Steps to Become an Owner',
      subtitle: 'Simple, transparent, secure investment process',
      steps: [
        { number: '01', title: 'Choose a Horse', desc: 'Browse our curated horses, view pedigree, record and health files.' },
        { number: '02', title: 'Purchase Shares', desc: 'Complete purchase via crypto wallet or fiat; hold on-chain ownership.' },
        { number: '03', title: 'Earn Returns', desc: 'When the horse wins or the asset appreciates, earn proportional distributions.' },
      ],
    },
    featuredHorsesTitle: 'Featured Horses',
    featuredHorsesSubtitle: 'Invest in premium equine assets, share champion glory',
    comingSoon: 'Coming Soon',
    contactMapPlaceholder: 'Map location - Singapore Headquarters',
    viewDetail: 'View Details',
    viewAllHorses: 'View All Horses',
    championBloodline: 'Champion',
    hot: 'Hot',
    newListing: 'New',
    winRate: 'Win Rate',
    record: 'Record',
    soldShare: 'Sold',
    pricePerShare: 'Per Share',
    whyRwaSubtitle: 'Redefining asset ownership',
    trustSubtitle: 'Transparent, compliant legal architecture',
    testimonialsTitle: 'Participant Stories',
    testimonialsSubtitle: 'Real participation experiences',
    testimonialsAnnualized: 'annualized',
    testimonialsList: [
      { text: 'As a tech professional, I\'ve always been interested in blockchain and real assets. Equine RWA let me participate in racehorse investment at an affordable level. My Thunder Strike share paid out after its first win!', name: 'Zhang Ming', title: 'Software Engineer · 3 horse shares', returnPct: '+24%' },
      { text: 'I\'ve loved horses since I was a child but never thought I could be an owner. Through this platform I bought shares in Golden Legacy — now I can watch training and races live. Amazing!', name: 'Li Xinyi', title: 'Marketing Director · 2 horse shares', returnPct: '+18%' },
      { text: 'I\'ve been involved in the racing industry for years, but traditional ownership can be capital-intensive and opaque. Equine RWA introduced a clearer structure for participation. I appreciate being able to follow performance updates while knowing the operational decisions remain with the professionals.', name: 'Chen Wei', title: 'Horse Enthusiast · 4 horse shares', returnPct: '+24%', tagline: 'Participation based on race performance' },
      { text: 'What attracted me to Equine RWA wasn\'t returns, but structure. The platform helped me understand how co-ownership works without having to manage training, logistics, or daily operations. It feels like a more disciplined way to be involved.', name: 'David Lee', title: 'Private Investor · 2 horse shares', returnPct: '+18%', tagline: 'Long-term participation' },
      { text: 'As a long-time follower of thoroughbred racing, I value transparency. Through Equine RWA, I can track ownership details, race participation, and asset updates in one place. It\'s not about speculation — it\'s about informed participation.', name: 'Sophia Tan', title: 'Family Office Associate · 5 horse shares', returnPct: '+22%', tagline: 'Asset-based participation' },
    ],
    partnersTitle: 'Partners',
    partnersSubtitle: 'Trusted platform with top institutions',
    partnersList: [
      { icon: 'fa-university', name: 'Global Equine Federation' },
      { icon: 'fa-shield-alt', name: 'International Insurance' },
      { icon: 'fa-briefcase', name: 'Blockchain Custody' },
      { icon: 'fa-gavel', name: 'Law Firms' },
      { icon: 'fa-hospital', name: 'Veterinary Certification' },
      { icon: 'fa-newspaper', name: 'Equine Media' },
    ],
    faqTitle: 'FAQ',
    faqSubtitle: 'Answers to your questions',
    faqItems: [
      { q: 'What is Equine RWA?', a: 'Equine RWA is a platform that tokenizes real racehorse assets. Through blockchain, we split economic rights into tradable tokens so more people can participate with lower barriers. Each token is backed by real horses with full pedigree, health and insurance records.' },
      { q: 'How much do I need to start?', a: 'Minimum investment varies by horse; typically from $1,000 to $5,000 per share. You can choose according to your budget. We support crypto and fiat payment.' },
      { q: 'How are returns calculated and distributed?', a: 'Returns come from race prizes, breeding fees and asset appreciation. All distributions are sent to your wallet automatically by share proportion. Everything is transparent and verifiable on-chain. We do not promise fixed returns; all outcomes are performance-based.' },
      { q: 'What are the risks?', a: 'Main risks: 1) Race performance (horse may lose); 2) Health (injuries, though covered by insurance); 3) Liquidity (secondary market may be limited); 4) Regulation (laws may change). We recommend reading our risk disclosure and diversifying.' },
      { q: 'How do you ensure compliance and security?', a: 'We work with top law firms and have a clear legal structure (SPV/trust). All horses are held by licensed custodians with full veterinary and insurance records. The platform is audited and all transactions are on-chain and transparent. We comply with local regulations and require KYC.' },
      { q: 'Can I sell my shares?', a: 'Yes, you can sell on our secondary market. Liquidity may vary by horse and demand. We are working with exchanges to improve liquidity.' },
    ],
    ctaNew: {
      title: 'Ready to become an owner?',
      subtitle: 'Explore featured horses and start your investment journey',
      primary: 'Enter DApp',
      secondary: 'Contact Us',
    },
    // About page
    aboutTitle: 'About Equine RWA',
    aboutSubtitle: 'Redefining racehorse asset ownership — everyone can own a champion',
    aboutMissionTitle: 'Our Mission',
    aboutMissionSubtitle: 'Building a transparent, fair, and trusted equine asset digitization platform',
    aboutMissionP1:
      'Equine RWA digitizes traditional racehorse assets through blockchain, enabling global investors to participate in this historic asset class with lower barriers. We provide real-asset backing, transparent operations, and performance-based distribution.',
    aboutMissionP2:
      'We believe that combining modern technology with the equine industry can create a more open, transparent, and fair investment environment — so everyone who loves racing can become an owner.',
    aboutValuesTitle: 'Core Values',
    aboutValues: [
      { icon: 'fa-shield-alt', title: 'Transparency & Integrity', desc: 'All transactions and asset information are transparent and verifiable on-chain, protecting investor rights.' },
      { icon: 'fa-balance-scale', title: 'Compliance', desc: 'We comply with local regulations and maintain clear legal and custody structures.' },
      { icon: 'fa-users', title: 'User First', desc: 'We put user experience and rights first, with professional service and support.' },
      { icon: 'fa-lightbulb', title: 'Innovation', desc: 'We continuously explore new models for blockchain and real assets, leading the industry.' },
    ],
    aboutTeamTitle: 'Our Team',
    aboutTeamSubtitle: 'Equine experts and blockchain talent',
    aboutTeamCards: [
      { icon: 'fa-user-tie', title: 'Equine Team', desc: '30+ years in the racing industry' },
      { icon: 'fa-laptop-code', title: 'Tech Team', desc: 'Leading blockchain developers' },
      { icon: 'fa-gavel', title: 'Legal & Compliance', desc: 'Senior financial and legal advisors' },
      { icon: 'fa-headset', title: 'Customer Support', desc: '24/7 professional support' },
    ],
    aboutCtaTitle: 'Join the Equine RWA Community',
    aboutCtaSubtitle: 'Join global owners and witness champions',
    // Contact page
    contactTitle: 'Contact Us',
    contactSubtitle: 'We are here to answer your questions',
    contactInfoTitle: 'Contact Information',
    contactFormTitle: 'Send a Message',
    contactFormDesc: 'Fill out the form below and we will reply within 24 hours',
    contactItems: [
      { icon: 'fa-envelope', title: 'Email', content: 'support@equinerwa.com\nbusiness@equinerwa.com' },
      { icon: 'fa-map-marker-alt', title: 'Address', content: '2 Orchard Turn, #05-03 ION Orchard\nSingapore 238801' },
      { icon: 'fa-comments', title: 'Social Media', social: true },
    ],
    contactSubjectOptions: [
      { value: '', label: 'Select topic' },
      { value: 'general', label: 'General inquiry' },
      { value: 'investment', label: 'Investment' },
      { value: 'technical', label: 'Technical support' },
      { value: 'partnership', label: 'Partnership' },
      { value: 'media', label: 'Media' },
      { value: 'other', label: 'Other' },
    ],
    contactThankYou: 'Thank you for your message. We will reply within 24 hours.',
    contactName: 'Name',
    contactNamePlaceholder: 'Enter your name',
    contactEmail: 'Email',
    contactSubject: 'Subject',
    contactMessage: 'Message',
    contactMessagePlaceholder: 'Describe your question or request...',
    contactSend: 'Send Message',
    // Marketplace page
    marketplacePageTitle: 'Horse Marketplace',
    marketplacePageSubtitle: 'Discover premium equine assets and start your investment journey',
    breadcrumbHome: 'Home',
    footerPlatformTitle: 'Platform',
    footerResourcesTitle: 'Resources',
    footerContactTitle: 'Contact',
    whyEquineRwa: {
      ...content.whyEquineRwa,
      title: 'Why Equine RWA Redefines Asset Ownership',
      summary: 'Equine RWA connects real assets with on-chain transparency without sacrificing authenticity, governance, or risk awareness.',
      blocks: blocksEn,
    },
    assetIntegrity: {
      ...content.assetIntegrity,
      title: 'Asset Trust & Structural Integrity',
      items: assetIntegrityItemsEn,
    },
    legalArchitecture: {
      ...content.legalArchitecture,
      title: 'Transparent Legal Architecture',
      titleEn: 'Transparent Legal Architecture',
      steps: legalStepsEn,
      paragraphZh: legalParagraphEn,
    },
    howToGetStarted: {
      ...content.howToGetStarted,
      titleZh: 'How to Get Started',
      steps: howToStepsEn,
    },
    marketplace: { ...content.marketplace, buyButton: 'Buy Now', statLabels: { speed: 'Speed', stamina: 'Stamina', power: 'Power' } },
    nftData: nftDataEn,
    footer: {
      ...content.footer,
      description: 'Global equine asset digitization platform. Everyone can own champion racehorses.',
      taglineZh: 'From grassland to on-chain, let every horse have a digital soul',
      riskDisclaimerZh:
        'Risk Disclaimer: Participation in Equine RWA involves real-world asset characteristics. Any returns are based on actual race performance and asset operations, and do not constitute fixed or guaranteed returns.',
    },
  },
  ko: {
    logoAlt: '경마 RWA 거래 플랫폼',
    nav: [
      { label: 'RWA 마켓플레이스', href: '#marketplace' },
      { label: '왜 Equine RWA', href: '#why' },
    ],
    navItems: [
      { label: '홈', href: '#' },
      { label: '마켓플레이스', href: '#' },
      { label: '소개', href: '#why-rwa' },
      { label: '이용 방법', href: '#how-it-works' },
      { label: '문의', href: '#cta-section' },
    ],
    ctaButton: 'DApp 입장',
    hero: { ...content.hero, ...heroKo },
    heroNew: {
      titleLine1: '챔피언을 소유하세요',
      titleLine2: '한 토큰부터 시작',
      subtitle: '글로벌 경마 자산 디지털화 플랫폼 · 투명 · 규정 준수 · 상생',
      ctaBrowse: '경주마 둘러보기',
      ctaLearn: '말 등록하기',
    },
    statsNew: [
      { target: 125000000, label: '플랫폼 자산 (USD)' },
      { target: 348, label: '프리미엄 경주마' },
      { target: 892000, label: '월 분배금 (USD)' },
      { target: 15600, label: '글로벌 회원' },
    ],
    howItWorksNew: {
      title: '세 단계로 마주 되기',
      subtitle: '간단하고 투명하며 안전한 투자 절차',
      steps: [
        { number: '01', title: '경주마 선택', desc: '엄선된 경주마를 둘러보고 혈통, 성적, 건강 기록을 확인하세요.' },
        { number: '02', title: '지분 구매', desc: '암호화폐 지갑 또는 법정화폐로 구매하고 온체인 소유권을 보유하세요.' },
        { number: '03', title: '수익 획득', desc: '경주마가 우승하거나 자산이 평가될 때 지분에 따라 분배금을 받습니다.' },
      ],
    },
    featuredHorsesTitle: '추천 경주마',
    featuredHorsesSubtitle: '프리미엄 경주마 자산에 투자하고 챔피언의 영광을 나누세요',
    comingSoon: '준비 중',
    contactMapPlaceholder: '지도 위치 - 싱가포르 본사',
    viewDetail: '상세 보기',
    viewAllHorses: '전체 경주마 보기',
    championBloodline: '챔피언',
    hot: '인기',
    newListing: '신규',
    winRate: '승률',
    record: '성적',
    soldShare: '판매됨',
    pricePerShare: '지분당',
    whyRwaSubtitle: '자산 소유권 재정의',
    trustSubtitle: '투명하고 규정 준수하는 법적 아키텍처',
    testimonialsTitle: '참여자 스토리',
    testimonialsSubtitle: '실제 참여 경험 공유',
    testimonialsAnnualized: '연환산',
    testimonialsList: [
      { text: '기술 업계에 종사하면서 블록체인과 실물 자산에 항상 관심이 있었습니다. Equine RWA로 부담 없이 경주마 투자에 참여했고, Thunder Strike 지분이 첫 우승 후 분배금을 받았습니다!', name: 'Zhang Ming', title: '소프트웨어 엔지니어 · 3마리 지분', returnPct: '+24%' },
      { text: '어릴 때부터 말을 좋아했지만 마주가 될 수 있을 줄은 몰랐습니다. 이 플랫폼으로 Golden Legacy 지분을 구매했고, 이제 훈련과 경주를 실시간으로 볼 수 있어요. 대단해요!', name: 'Li Xinyi', title: '마케팅 디렉터 · 2마리 지분', returnPct: '+18%' },
      { text: '경마 업계에 오랫동안 관여했지만 기존 마주 모델은 자금 문턱이 높고 투명성이 부족한 경우가 많았습니다. Equine RWA는 더 명확한 참여 구조를 제공합니다. 성적 업데이트를 꾸준히 받을 수 있고, 운영 결정은 전문 팀이 담당해 안심됩니다.', name: 'Chen Wei', title: '경마 애호가 · 4마리 지분', returnPct: '+24%', tagline: '경주 성적 기반 참여' },
      { text: 'Equine RWA에 끌린 건 수익이 아니라 구조였습니다. 플랫폼으로 공동 소유가 어떻게 작동하는지 이해했고, 훈련·물류·일상 운영을 직접 관리할 필요가 없습니다. 더 체계적인 참여 방식이에요.', name: 'David Lee', title: '개인 투자자 · 2마리 지분', returnPct: '+18%', tagline: '장기 참여' },
      { text: '순혈 경주마를 오래 지켜본 애호가로서 투명성을 중시합니다. Equine RWA로 소유권 상세, 경주 참여, 자산 업데이트를 한곳에서 추적할 수 있습니다. 투기가 아니라 근거 있는 참여입니다.', name: 'Sophia Tan', title: '패밀리 오피스 · 5마리 지분', returnPct: '+22%', tagline: '자산 기반 참여' },
    ],
    partnersTitle: '파트너 및 전문 기관',
    partnersSubtitle: '최고 기관과 함께 신뢰할 수 있는 플랫폼을 구축합니다',
    partnersList: [
      { icon: 'fa-university', name: '글로벌 마협회' },
      { icon: 'fa-shield-alt', name: '국제 보험' },
      { icon: 'fa-briefcase', name: '블록체인 수탁' },
      { icon: 'fa-gavel', name: '법률 사무소' },
      { icon: 'fa-hospital', name: '수의 인증' },
      { icon: 'fa-newspaper', name: '경마 미디어' },
    ],
    faqTitle: '자주 묻는 질문',
    faqSubtitle: '궁금한 점에 답합니다',
    faqItems: [
      { q: 'Equine RWA란 무엇인가요?', a: 'Equine RWA는 실제 경주마 자산을 토큰화하는 플랫폼입니다. 블록체인으로 경제적 권리를 거래 가능한 토큰으로 나누어 더 많은 사람이 낮은 문턱으로 참여할 수 있습니다. 각 토큰은 혈통·건강·보험 기록이 갖춰진 실제 경주마에 담보됩니다.' },
      { q: '시작하려면 얼마가 필요하나요?', a: '최소 투자금은 경주마마다 다르며, 보통 지분당 $1,000~$5,000입니다. 예산에 맞게 선택할 수 있으며, 암호화폐 및 법정화폐 결제를 지원합니다.' },
      { q: '수익은 어떻게 계산·분배되나요?', a: '수익은 경주 상금, 번식 수수료, 자산 평가에 따른 것입니다. 모든 분배는 지분 비율에 따라 지갑으로 자동 전송되며, 온체인에서 투명하게 검증할 수 있습니다. 고정 수익을 약속하지 않으며, 모든 결과는 실적 기반입니다.' },
      { q: '어떤 리스크가 있나요?', a: '주요 리스크: 1) 경주 성적(말이 질 수 있음); 2) 건강(부상, 보험 적용); 3) 유동성(2차 시장 제한 가능); 4) 규제(법규 변경 가능). 리스크 공시를 읽고 분산 투자할 것을 권합니다.' },
      { q: '규정 준수와 보안은 어떻게 보장하나요?', a: '최고 법률 사무소와 협력하여 명확한 법적 구조(SPV/신탁)를 갖추었습니다. 모든 말은 수의·보험 기록이 갖춰진 인가 수탁자가 보유합니다. 플랫폼은 감사를 받으며 모든 거래는 온체인에서 투명합니다. 현지 규정을 준수하며 KYC를 요구합니다.' },
      { q: '지분을 팔 수 있나요?', a: '네, 2차 시장에서 판매할 수 있습니다. 유동성은 경주마와 수요에 따라 다를 수 있으며, 거래소와 협력해 유동성을 높이고 있습니다.' },
    ],
    ctaNew: {
      title: '마주가 준비되셨나요?',
      subtitle: '추천 경주마를 탐색하고 투자 여정을 시작하세요',
      primary: 'DApp 입장',
      secondary: '문의하기',
    },
    footerPlatformTitle: '플랫폼',
    footerResourcesTitle: '리소스',
    footerContactTitle: '문의',
    // About page
    aboutTitle: 'Equine RWA 소개',
    aboutSubtitle: '경주마 자산 소유권 재정의 — 누구나 챔피언을 소유할 수 있습니다',
    aboutMissionTitle: '우리의 미션',
    aboutMissionSubtitle: '투명하고 공정하며 신뢰할 수 있는 경마 자산 디지털화 플랫폼 구축',
    aboutMissionP1:
      'Equine RWA는 블록체인으로 전통 경주마 자산을 디지털화하여 전 세계 투자자가 낮은 문턱으로 이 역사적인 자산 클래스에 참여할 수 있게 합니다. 실물 자산 담보, 투명한 운영, 실적 기반 분배를 제공합니다.',
    aboutMissionP2:
      '현대 기술과 경마 산업의 결합으로 더 개방적이고 투명하며 공정한 투자 환경을 만들 수 있다고 믿습니다. 경마를 사랑하는 모든 이가 마주가 될 수 있도록 합니다.',
    aboutValuesTitle: '핵심 가치',
    aboutValues: [
      { icon: 'fa-shield-alt', title: '투명·신뢰', desc: '모든 거래와 자산 정보는 온체인에서 투명하고 검증 가능하며, 투자자 권리를 보호합니다.' },
      { icon: 'fa-balance-scale', title: '규정 준수', desc: '각국 규정을 엄수하고 명확한 법적·수탁 구조를 유지합니다.' },
      { icon: 'fa-users', title: '사용자 우선', desc: '사용자 경험과 권리를 최우선으로 하며 전문 서비스와 지원을 제공합니다.' },
      { icon: 'fa-lightbulb', title: '혁신', desc: '블록체인과 실물 자산 결합의 새로운 모델을 지속 탐구하며 업계를 선도합니다.' },
    ],
    aboutTeamTitle: '전문 팀',
    aboutTeamSubtitle: '경마 전문가와 블록체인 기술 인력',
    aboutTeamCards: [
      { icon: 'fa-user-tie', title: '경마 팀', desc: '30년 이상 경마 업계 경험' },
      { icon: 'fa-laptop-code', title: '기술 팀', desc: '최고 블록체인 개발자' },
      { icon: 'fa-gavel', title: '법률·규정 준수', desc: '선임 금융·법률 자문' },
      { icon: 'fa-headset', title: '고객 지원', desc: '24/7 전문 지원' },
    ],
    aboutCtaTitle: 'Equine RWA 커뮤니티에 참여하세요',
    aboutCtaSubtitle: '전 세계 마주와 함께 챔피언의 탄생을 목격하세요',
    // Contact page
    contactTitle: '문의하기',
    contactSubtitle: '궁금한 점을 언제든 문의해 주세요',
    contactInfoTitle: '연락처',
    contactFormTitle: '메시지 보내기',
    contactFormDesc: '아래 양식을 작성해 주시면 24시간 내에 답변드립니다',
    contactItems: [
      { icon: 'fa-envelope', title: '이메일', content: 'support@equinerwa.com\nbusiness@equinerwa.com' },
      { icon: 'fa-map-marker-alt', title: '주소', content: '2 Orchard Turn, #05-03 ION Orchard\nSingapore 238801' },
      { icon: 'fa-comments', title: '소셜 미디어', social: true },
    ],
    contactSubjectOptions: [
      { value: '', label: '문의 주제 선택' },
      { value: 'general', label: '일반 문의' },
      { value: 'investment', label: '투자 관련' },
      { value: 'technical', label: '기술 지원' },
      { value: 'partnership', label: '제휴 문의' },
      { value: 'media', label: '미디어' },
      { value: 'other', label: '기타' },
    ],
    contactThankYou: '메시지를 보내 주셔서 감사합니다. 24시간 내에 답변드리겠습니다.',
    contactName: '이름',
    contactNamePlaceholder: '이름을 입력하세요',
    contactEmail: '이메일',
    contactSubject: '주제',
    contactMessage: '메시지 내용',
    contactMessagePlaceholder: '문의 내용이나 요청을 자세히 적어 주세요...',
    contactSend: '메시지 보내기',
    // Marketplace page
    marketplacePageTitle: '경주마 마켓플레이스',
    marketplacePageSubtitle: '프리미엄 경주마 자산을 발견하고 투자 여정을 시작하세요',
    breadcrumbHome: '홈',
    whyEquineRwa: {
      ...content.whyEquineRwa,
      title: '왜 Equine RWA가 자산 소유권을 재정의하는가',
      titleEn: '왜 Equine RWA가 자산 소유권을 재정의하는가',
      summary: 'Equine RWA는 자산의 진정성·거버넌스·리스크 인식을 희생하지 않고 실물 자산과 온체인 투명성을 연결합니다.',
      blocks: blocksKo,
    },
    assetIntegrity: {
      ...content.assetIntegrity,
      title: '자산 신뢰 및 구조적 무결성',
      items: assetIntegrityItemsKo,
    },
    legalArchitecture: {
      ...content.legalArchitecture,
      title: '투명한 법적 아키텍처',
      titleEn: '투명한 법적 아키텍처',
      steps: legalStepsKo,
      paragraphZh: legalParagraphKo,
    },
    howToGetStarted: {
      ...content.howToGetStarted,
      titleZh: '시작하기',
      steps: howToStepsKo,
    },
    marketplace: {
      ...content.marketplace,
      titleRest: 'Equine RWA NFT 마켓플레이스',
      subtitle: '엄선된 최고급 디지털 경주마 컬렉션',
      buyButton: '즉시 구매',
      statLabels: { speed: '속도', stamina: '스태미나', power: '파워' },
    },
    nftData: nftDataKo,
    footer: {
      ...content.footer,
      description: '글로벌 경마 자산 디지털화 플랫폼. 누구나 챔피언 경주마를 소유할 수 있습니다.',
      tagline: '블록체인 기술로 경마 소유의 투명성과 접근을 제공합니다.',
      taglineZh: '초원에서 온체인까지, 모든 말에 디지털 영혼을',
      socialTitle: '소셜 미디어',
      copyright: '© 2026 Equine RWA. All rights reserved.',
      riskDisclaimerZh:
        '리스크 면책: Equine RWA 참여에는 실물 자산 특성이 수반됩니다. 모든 수익은 실제 경주 성적 및 자산 운영에 기반하며, 고정 또는 보장 수익을 구성하지 않습니다.',
    },
  },
  ja: {
    logoAlt: 'ホース RWA 取引プラットフォーム',
    nav: [
      { label: 'RWA マーケットプレイス', href: '#marketplace' },
      { label: 'なぜ Equine RWA', href: '#why' },
    ],
    navItems: [
      { label: 'ホーム', href: '#' },
      { label: 'マーケットプレイス', href: '#' },
      { label: '会社概要', href: '#why-rwa' },
      { label: 'ご利用方法', href: '#how-it-works' },
      { label: 'お問い合わせ', href: '#cta-section' },
    ],
    ctaButton: 'DApp に入る',
    hero: { ...content.hero, ...heroJa },
    heroNew: {
      titleLine1: 'チャンピオンを所有',
      titleLine2: '1トークンから始める',
      subtitle: 'グローバル競馬資産デジタル化プラットフォーム · 透明 · コンプライアンス · ウィンウィン',
      ctaBrowse: '競走馬を閲覧',
      ctaLearn: '馬を登録',
    },
    statsNew: [
      { target: 125000000, label: 'プラットフォーム資産 (USD)' },
      { target: 348, label: 'プレミアム競走馬' },
      { target: 892000, label: '月次分配 (USD)' },
      { target: 15600, label: 'グローバル会員' },
    ],
    howItWorksNew: {
      title: '3ステップで馬主に',
      subtitle: 'シンプルで透明、安全な投資プロセス',
      steps: [
        { number: '01', title: '競走馬を選ぶ', desc: '厳選された競走馬を閲覧し、血統・成績・健康記録を確認できます。' },
        { number: '02', title: '持分を購入', desc: '暗号ウォレットまたは法定通貨で購入し、オンチェーン所有権を保有。' },
        { number: '03', title: 'リターンを得る', desc: '馬が勝利したり資産が評価されたとき、持分に応じて分配を受け取ります。' },
      ],
    },
    featuredHorsesTitle: '注目の競走馬',
    featuredHorsesSubtitle: 'プレミアム競走馬資産に投資し、チャンピオンの栄光を共有',
    comingSoon: '近日公開',
    contactMapPlaceholder: '地図 - シンガポール本社',
    viewDetail: '詳細を見る',
    viewAllHorses: 'すべての競走馬を見る',
    championBloodline: 'チャンピオン',
    hot: '人気',
    newListing: '新規',
    winRate: '勝率',
    record: '成績',
    soldShare: '販売済',
    pricePerShare: '持分あたり',
    whyRwaSubtitle: '資産所有の再定義',
    trustSubtitle: '透明でコンプライアンスな法務アーキテクチャ',
    testimonialsTitle: '参加者の声',
    testimonialsSubtitle: '実際の参加体験を共有',
    testimonialsAnnualized: '年換算',
    testimonialsList: [
      { text: '技術者としてブロックチェーンと実物資産にずっと関心がありました。Equine RWAで手頃に競馬投資に参加でき、Thunder Strikeの持分が初勝利後に分配を受け取りました！', name: 'Zhang Ming', title: 'ソフトウェアエンジニア · 3馬分', returnPct: '+24%' },
      { text: '子供の頃から馬が好きでしたが、馬主になれるとは思いませんでした。このプラットフォームでGolden Legacyの持分を購入し、今は調教やレースをライブで見られます。素晴らしい！', name: 'Li Xinyi', title: 'マーケティングディレクター · 2馬分', returnPct: '+18%' },
      { text: '競馬業界に長年関わってきましたが、従来の馬主モデルは資金ハードルが高く不透明なことが多い。Equine RWAはより明確な参加構造を提供してくれます。成績更新を追いながら、運営判断はプロに任せられるのが安心です。', name: 'Chen Wei', title: '競馬愛好家 · 4馬分', returnPct: '+24%', tagline: 'レース成績に基づく参加' },
      { text: 'Equine RWAに惹かれたのはリターンではなく構造でした。プラットフォームで共同所有の仕組みを理解でき、調教・物流・日常運営を自ら管理する必要がありません。より規律ある参加の仕方だと感じます。', name: 'David Lee', title: '個人投資家 · 2馬分', returnPct: '+18%', tagline: '長期参加' },
      { text: 'サラブレッド競馬を長年フォローする者として、透明性を重視しています。Equine RWAでは所有権詳細・レース参加・資産更新を一箇所で追跡できます。投機ではなく、情報に基づいた参加です。', name: 'Sophia Tan', title: 'ファミリーオフィス · 5馬分', returnPct: '+22%', tagline: '資産ベースの参加' },
    ],
    partnersTitle: 'パートナー・専門機関',
    partnersSubtitle: 'トップ機関と信頼できるプラットフォームを構築',
    partnersList: [
      { icon: 'fa-university', name: 'グローバル馬業連盟' },
      { icon: 'fa-shield-alt', name: '国際保険' },
      { icon: 'fa-briefcase', name: 'ブロックチェーン保管' },
      { icon: 'fa-gavel', name: '法律事務所' },
      { icon: 'fa-hospital', name: '獣医認証' },
      { icon: 'fa-newspaper', name: '競馬メディア' },
    ],
    faqTitle: 'よくある質問',
    faqSubtitle: 'お客様の疑問にお答えします',
    faqItems: [
      { q: 'Equine RWAとは？', a: 'Equine RWAは実際の競走馬資産をトークン化するプラットフォームです。ブロックチェーンで経済的権利を取引可能なトークンに分割し、より多くの方が低いハードルで参加できます。各トークンは血統・健康・保険記録を備えた実際の馬に裏付けられています。' },
      { q: '始めるにはいくら必要ですか？', a: '最低投資額は馬により異なり、通常持分あたり$1,000～$5,000です。ご予算に合わせて選択でき、暗号資産・法定通貨の支払いに対応しています。' },
      { q: 'リターンはどのように計算・分配されますか？', a: 'リターンはレース賞金・種牡馬料・資産評価に基づきます。すべての分配は持分比率に応じてウォレットに自動送金され、オンチェーンで透明に検証できます。固定リターンは約束せず、すべての結果は実績ベースです。' },
      { q: 'リスクはありますか？', a: '主なリスク：1) レース成績（馬が負ける可能性）；2) 健康（怪我、保険でカバー）；3) 流動性（二次市場が限定的な場合あり）；4) 規制（法改正の可能性）。リスク開示をお読みいただき、分散投資を推奨します。' },
      { q: 'コンプライアンスとセキュリティはどう担保していますか？', a: 'トップ法律事務所と協力し、明確な法務構造（SPV/信託）を構築しています。すべての馬は獣医・保険記録を備えた認可保管者が保有。プラットフォームは監査を受け、取引はオンチェーンで透明。現地規制を遵守しKYCを求めています。' },
      { q: '持分は売れますか？', a: 'はい、二次市場で売却できます。流動性は馬や需要により異なります。取引所と連携し流動性向上を進めています。' },
    ],
    ctaNew: {
      title: '馬主の準備はできましたか？',
      subtitle: '注目の競走馬を探索し、投資の旅を始めましょう',
      primary: 'DApp に入る',
      secondary: 'お問い合わせ',
    },
    footerPlatformTitle: 'プラットフォーム',
    footerResourcesTitle: 'リソース',
    footerContactTitle: 'お問い合わせ',
    // About page
    aboutTitle: 'Equine RWA について',
    aboutSubtitle: '競馬資産所有を再定義 — 誰もがチャンピオンを所有できる',
    aboutMissionTitle: '私たちのミッション',
    aboutMissionSubtitle: '透明で公正、信頼できる競馬資産デジタル化プラットフォームの構築',
    aboutMissionP1:
      'Equine RWAはブロックチェーンで従来の競走馬資産をデジタル化し、世界中の投資家が低いハードルでこの歴史ある資産クラスに参加できるようにします。実物資産裏付け、透明な運営、実績ベースの分配を提供します。',
    aboutMissionP2:
      '現代技術と競馬業界の融合により、よりオープンで透明かつ公正な投資環境を創造できると信じています。競馬を愛するすべての方が馬主になれるように。',
    aboutValuesTitle: 'コアバリュー',
    aboutValues: [
      { icon: 'fa-shield-alt', title: '透明性・誠実', desc: 'すべての取引と資産情報はオンチェーンで透明・検証可能であり、投資家の権利を守ります。' },
      { icon: 'fa-balance-scale', title: 'コンプライアンス', desc: '各地の規制を厳守し、明確な法務・保管構造を維持しています。' },
      { icon: 'fa-users', title: 'ユーザー第一', desc: 'ユーザー体験と権利を最優先に、専門的なサービスとサポートを提供します。' },
      { icon: 'fa-lightbulb', title: 'イノベーション', desc: 'ブロックチェーンと実物資産の新たな結合モデルを探求し、業界をリードします。' },
    ],
    aboutTeamTitle: '専門チーム',
    aboutTeamSubtitle: '競馬の専門家とブロックチェーン技術者',
    aboutTeamCards: [
      { icon: 'fa-user-tie', title: '競馬チーム', desc: '30年以上の競馬業界経験' },
      { icon: 'fa-laptop-code', title: '技術チーム', desc: 'トップブロックチェーン開発者' },
      { icon: 'fa-gavel', title: '法務・コンプライアンス', desc: 'シニア金融・法務アドバイザー' },
      { icon: 'fa-headset', title: 'カスタマーサポート', desc: '24時間365日専門サポート' },
    ],
    aboutCtaTitle: 'Equine RWA コミュニティに参加',
    aboutCtaSubtitle: '世界中の馬主とチャンピオンの誕生を目撃',
    // Contact page
    contactTitle: 'お問い合わせ',
    contactSubtitle: 'ご質問はいつでもお気軽にどうぞ',
    contactInfoTitle: '連絡先',
    contactFormTitle: 'メッセージを送る',
    contactFormDesc: '下記フォームにご記入いただければ、24時間以内にご返信します',
    contactItems: [
      { icon: 'fa-envelope', title: 'メール', content: 'support@equinerwa.com\nbusiness@equinerwa.com' },
      { icon: 'fa-map-marker-alt', title: '住所', content: '2 Orchard Turn, #05-03 ION Orchard\nSingapore 238801' },
      { icon: 'fa-comments', title: 'ソーシャルメディア', social: true },
    ],
    contactSubjectOptions: [
      { value: '', label: 'お問い合わせ種別を選択' },
      { value: 'general', label: '一般のお問い合わせ' },
      { value: 'investment', label: '投資関連' },
      { value: 'technical', label: '技術サポート' },
      { value: 'partnership', label: 'パートナーシップ' },
      { value: 'media', label: 'メディア' },
      { value: 'other', label: 'その他' },
    ],
    contactThankYou: 'メッセージありがとうございます。24時間以内にご返信します。',
    contactName: 'お名前',
    contactNamePlaceholder: 'お名前を入力',
    contactEmail: 'メール',
    contactSubject: '件名',
    contactMessage: 'メッセージ内容',
    contactMessagePlaceholder: 'ご質問やご要望を詳しくご記入ください...',
    contactSend: '送信',
    // Marketplace page
    marketplacePageTitle: '競走馬マーケットプレイス',
    marketplacePageSubtitle: 'プレミアム競走馬資産を発見し、投資の旅を始めましょう',
    breadcrumbHome: 'ホーム',
    whyEquineRwa: {
      ...content.whyEquineRwa,
      title: 'なぜ Equine RWA が資産所有を再定義するか',
      titleEn: 'なぜ Equine RWA が資産所有を再定義するか',
      summary: 'Equine RWA は、資産の真正性、ガバナンス、リスク認識を損なうことなく、現実資産とオンチェーンの透明性を結びつけます。',
      blocks: blocksJa,
    },
    assetIntegrity: {
      ...content.assetIntegrity,
      title: '資産の信頼性と構造の完全性',
      items: assetIntegrityItemsJa,
    },
    legalArchitecture: {
      ...content.legalArchitecture,
      title: '透明な法務アーキテクチャ',
      titleEn: '透明な法務アーキテクチャ',
      steps: legalStepsJa,
      paragraphZh: legalParagraphJa,
    },
    howToGetStarted: {
      ...content.howToGetStarted,
      titleZh: '始め方',
      steps: howToStepsJa,
    },
    marketplace: {
      ...content.marketplace,
      titleRest: 'Equine RWA NFT マーケットプレイス',
      subtitle: '厳選された最高級デジタル競走馬コレクション',
      buyButton: '今すぐ購入',
      statLabels: { speed: 'スピード', stamina: 'スタミナ', power: 'パワー' },
    },
    nftData: nftDataJa,
    footer: {
      ...content.footer,
      description: 'グローバル競馬資産デジタル化プラットフォーム。誰もがチャンピオン競走馬を所有できます。',
      tagline: 'ブロックチェーン技術により競馬所有の透明性とアクセスを実現。',
      taglineZh: '草原からチェーンへ、すべての馬にデジタルな魂を',
      socialTitle: 'ソーシャルメディア',
      copyright: '© 2026 Equine RWA. All rights reserved.',
      riskDisclaimerZh:
        'リスク免責事項：Equine RWA への参加には現実世界の資産特性が伴います。いかなるリターンも実際の競走成績および資産運営に基づき、固定または保証されたリターンを構成しません。',
    },
  },
  vi: {
    logoAlt: 'Nền tảng giao dịch RWA Ngựa',
    nav: [
      { label: 'Sàn giao dịch RWA', href: '#marketplace' },
      { label: 'Tại sao Equine RWA', href: '#why' },
    ],
    navItems: [
      { label: 'Trang chủ', href: '#' },
      { label: 'Sàn giao dịch', href: '#' },
      { label: 'Giới thiệu', href: '#why-rwa' },
      { label: 'Cách hoạt động', href: '#how-it-works' },
      { label: 'Liên hệ', href: '#cta-section' },
    ],
    ctaButton: 'Vào DApp',
    hero: { ...content.hero, ...heroVi },
    heroNew: {
      titleLine1: 'Sở hữu nhà vô địch',
      titleLine2: 'Bắt đầu từ một token',
      subtitle: 'Nền tảng số hóa tài sản ngựa đua toàn cầu · Minh bạch · Tuân thủ · Cùng thắng',
      ctaBrowse: 'Xem ngựa đua',
      ctaLearn: 'Đăng ký ngựa',
    },
    statsNew: [
      { target: 125000000, label: 'Tài sản nền tảng (USD)' },
      { target: 348, label: 'Ngựa đua cao cấp' },
      { target: 892000, label: 'Phân phối hàng tháng (USD)' },
      { target: 15600, label: 'Thành viên toàn cầu' },
    ],
    howItWorksNew: {
      title: 'Ba bước trở thành chủ sở hữu',
      subtitle: 'Quy trình đầu tư đơn giản, minh bạch, an toàn',
      steps: [
        { number: '01', title: 'Chọn ngựa đua', desc: 'Duyệt ngựa đua được tuyển chọn, xem gia phả, thành tích và hồ sơ sức khỏe.' },
        { number: '02', title: 'Mua cổ phần', desc: 'Hoàn tất mua qua ví tiền mã hóa hoặc fiat; nắm giữ quyền sở hữu on-chain.' },
        { number: '03', title: 'Nhận lợi nhuận', desc: 'Khi ngựa thắng hoặc tài sản tăng giá, nhận phân phối theo tỷ lệ cổ phần.' },
      ],
    },
    featuredHorsesTitle: 'Ngựa đua nổi bật',
    featuredHorsesSubtitle: 'Đầu tư tài sản ngựa cao cấp, chia sẻ vinh quang nhà vô địch',
    comingSoon: 'Sắp ra mắt',
    contactMapPlaceholder: 'Vị trí bản đồ - Trụ sở Singapore',
    viewDetail: 'Xem chi tiết',
    viewAllHorses: 'Xem tất cả ngựa đua',
    championBloodline: 'Nhà vô địch',
    hot: 'Hot',
    newListing: 'Mới',
    winRate: 'Tỷ lệ thắng',
    record: 'Thành tích',
    soldShare: 'Đã bán',
    pricePerShare: 'Mỗi cổ phần',
    whyRwaSubtitle: 'Định nghĩa lại quyền sở hữu tài sản',
    trustSubtitle: 'Kiến trúc pháp lý minh bạch, tuân thủ',
    testimonialsTitle: 'Câu chuyện người tham gia',
    testimonialsSubtitle: 'Trải nghiệm tham gia thực tế',
    testimonialsAnnualized: 'quy đổi năm',
    testimonialsList: [
      { text: 'Là người làm công nghệ, tôi luôn quan tâm đến blockchain và tài sản thực. Equine RWA giúp tôi tham gia đầu tư ngựa đua với mức phù hợp. Cổ phần Thunder Strike của tôi đã được phân phối sau chiến thắng đầu tiên!', name: 'Zhang Ming', title: 'Kỹ sư phần mềm · 3 cổ phần ngựa', returnPct: '+24%' },
      { text: 'Tôi yêu ngựa từ nhỏ nhưng chưa từng nghĩ có thể làm chủ sở hữu. Qua nền tảng này tôi mua cổ phần Golden Legacy — giờ có thể xem tập luyện và đua trực tiếp. Tuyệt vời!', name: 'Li Xinyi', title: 'Giám đốc Marketing · 2 cổ phần ngựa', returnPct: '+18%' },
      { text: 'Tôi tham gia ngành đua ngựa nhiều năm, nhưng sở hữu truyền thống thường vốn cao và thiếu minh bạch. Equine RWA mang lại cấu trúc tham gia rõ ràng hơn. Tôi theo dõi cập nhật thành tích trong khi quyết định vận hành do đội ngũ chuyên nghiệp đảm nhiệm.', name: 'Chen Wei', title: 'Người đam mê ngựa · 4 cổ phần ngựa', returnPct: '+24%', tagline: 'Tham gia dựa trên thành tích đua' },
      { text: 'Điều thu hút tôi ở Equine RWA không phải lợi nhuận mà là cấu trúc. Nền tảng giúp tôi hiểu cách đồng sở hữu hoạt động mà không cần quản lý tập luyện, hậu cần hay vận hành hàng ngày. Đó là cách tham gia có kỷ luật hơn.', name: 'David Lee', title: 'Nhà đầu tư cá nhân · 2 cổ phần ngựa', returnPct: '+18%', tagline: 'Tham gia dài hạn' },
      { text: 'Là người theo dõi đua ngựa thuần chủng lâu năm, tôi coi trọng minh bạch. Qua Equine RWA, tôi có thể theo dõi chi tiết sở hữu, tham gia đua và cập nhật tài sản ở một nơi. Không phải đầu cơ — mà là tham gia có cơ sở.', name: 'Sophia Tan', title: 'Family Office · 5 cổ phần ngựa', returnPct: '+22%', tagline: 'Tham gia dựa trên tài sản' },
    ],
    partnersTitle: 'Đối tác và tổ chức chuyên nghiệp',
    partnersSubtitle: 'Xây dựng nền tảng đáng tin cậy với các tổ chức hàng đầu',
    partnersList: [
      { icon: 'fa-university', name: 'Liên đoàn Ngựa Toàn cầu' },
      { icon: 'fa-shield-alt', name: 'Bảo hiểm Quốc tế' },
      { icon: 'fa-briefcase', name: 'Ủy thác Blockchain' },
      { icon: 'fa-gavel', name: 'Văn phòng Luật' },
      { icon: 'fa-hospital', name: 'Chứng nhận Thú y' },
      { icon: 'fa-newspaper', name: 'Truyền thông Ngựa đua' },
    ],
    faqTitle: 'Câu hỏi thường gặp',
    faqSubtitle: 'Giải đáp thắc mắc của bạn',
    faqItems: [
      { q: 'Equine RWA là gì?', a: 'Equine RWA là nền tảng token hóa tài sản ngựa đua thực. Qua blockchain, chúng tôi chia quyền kinh tế thành token có thể giao dịch để nhiều người tham gia với rào cản thấp hơn. Mỗi token được bảo chứng bởi ngựa thực với đầy đủ gia phả, sức khỏe và bảo hiểm.' },
      { q: 'Cần bao nhiêu để bắt đầu?', a: 'Đầu tư tối thiểu tùy từng ngựa; thường từ $1.000 đến $5.000 mỗi cổ phần. Bạn có thể chọn theo ngân sách. Chúng tôi hỗ trợ thanh toán crypto và fiat.' },
      { q: 'Lợi nhuận được tính và phân phối thế nào?', a: 'Lợi nhuận đến từ giải thưởng đua, phí nhân giống và tăng giá tài sản. Mọi phân phối được gửi tự động vào ví theo tỷ lệ cổ phần. Minh bạch và có thể xác minh on-chain. Chúng tôi không hứa lợi nhuận cố định; mọi kết quả dựa trên hiệu suất.' },
      { q: 'Rủi ro là gì?', a: 'Rủi ro chính: 1) Thành tích đua (ngựa có thể thua); 2) Sức khỏe (chấn thương, có bảo hiểm); 3) Thanh khoản (thị trường thứ cấp có thể hạn chế); 4) Quy định (pháp luật có thể thay đổi). Khuyến nghị đọc công bố rủi ro và đa dạng hóa.' },
      { q: 'Làm sao đảm bảo tuân thủ và bảo mật?', a: 'Chúng tôi hợp tác với văn phòng luật hàng đầu và có cấu trúc pháp lý rõ ràng (SPV/ủy thác). Mọi ngựa do bên ủy thác có giấy phép nắm giữ với hồ sơ thú y và bảo hiểm đầy đủ. Nền tảng được kiểm toán và mọi giao dịch on-chain minh bạch. Tuân thủ quy định địa phương và yêu cầu KYC.' },
      { q: 'Tôi có thể bán cổ phần không?', a: 'Có, bạn có thể bán trên thị trường thứ cấp. Thanh khoản có thể thay đổi theo ngựa và nhu cầu. Chúng tôi đang hợp tác với sàn để cải thiện thanh khoản.' },
    ],
    ctaNew: {
      title: 'Sẵn sàng trở thành chủ sở hữu?',
      subtitle: 'Khám phá ngựa đua nổi bật và bắt đầu hành trình đầu tư',
      primary: 'Vào DApp',
      secondary: 'Liên hệ',
    },
    footerPlatformTitle: 'Nền tảng',
    footerResourcesTitle: 'Tài nguyên',
    footerContactTitle: 'Liên hệ',
    // About page
    aboutTitle: 'Về Equine RWA',
    aboutSubtitle: 'Định nghĩa lại quyền sở hữu tài sản ngựa đua — mọi người đều có thể sở hữu nhà vô địch',
    aboutMissionTitle: 'Sứ mệnh của chúng tôi',
    aboutMissionSubtitle: 'Xây dựng nền tảng số hóa tài sản ngựa đua minh bạch, công bằng, đáng tin cậy',
    aboutMissionP1:
      'Equine RWA số hóa tài sản ngựa đua truyền thống qua blockchain, giúp nhà đầu tư toàn cầu tham gia lớp tài sản lịch sử này với rào cản thấp hơn. Chúng tôi cung cấp bảo chứng tài sản thực, vận hành minh bạch và phân phối dựa trên hiệu suất.',
    aboutMissionP2:
      'Chúng tôi tin rằng kết hợp công nghệ hiện đại với ngành ngựa có thể tạo ra môi trường đầu tư cởi mở, minh bạch và công bằng hơn — để mọi người yêu đua ngựa đều có thể trở thành chủ sở hữu.',
    aboutValuesTitle: 'Giá trị cốt lõi',
    aboutValues: [
      { icon: 'fa-shield-alt', title: 'Minh bạch & Chính trực', desc: 'Mọi giao dịch và thông tin tài sản minh bạch, có thể xác minh on-chain, bảo vệ quyền nhà đầu tư.' },
      { icon: 'fa-balance-scale', title: 'Tuân thủ', desc: 'Tuân thủ quy định địa phương và duy trì cấu trúc pháp lý, ủy thác rõ ràng.' },
      { icon: 'fa-users', title: 'Người dùng trên hết', desc: 'Đặt trải nghiệm và quyền lợi người dùng lên hàng đầu, cung cấp dịch vụ và hỗ trợ chuyên nghiệp.' },
      { icon: 'fa-lightbulb', title: 'Đổi mới', desc: 'Không ngừng khám phá mô hình mới kết hợp blockchain và tài sản thực, dẫn dắt ngành.' },
    ],
    aboutTeamTitle: 'Đội ngũ chuyên nghiệp',
    aboutTeamSubtitle: 'Chuyên gia ngựa và nhân tài blockchain',
    aboutTeamCards: [
      { icon: 'fa-user-tie', title: 'Đội ngựa đua', desc: 'Hơn 30 năm kinh nghiệm ngành đua ngựa' },
      { icon: 'fa-laptop-code', title: 'Đội công nghệ', desc: 'Nhà phát triển blockchain hàng đầu' },
      { icon: 'fa-gavel', title: 'Pháp lý & Tuân thủ', desc: 'Cố vấn tài chính và pháp lý cao cấp' },
      { icon: 'fa-headset', title: 'Hỗ trợ khách hàng', desc: 'Hỗ trợ chuyên nghiệp 24/7' },
    ],
    aboutCtaTitle: 'Tham gia cộng đồng Equine RWA',
    aboutCtaSubtitle: 'Cùng chủ sở hữu toàn cầu chứng kiến nhà vô địch ra đời',
    // Contact page
    contactTitle: 'Liên hệ',
    contactSubtitle: 'Chúng tôi sẵn sàng giải đáp mọi thắc mắc',
    contactInfoTitle: 'Thông tin liên hệ',
    contactFormTitle: 'Gửi tin nhắn',
    contactFormDesc: 'Điền form bên dưới, chúng tôi sẽ phản hồi trong 24 giờ',
    contactItems: [
      { icon: 'fa-envelope', title: 'Email', content: 'support@equinerwa.com\nbusiness@equinerwa.com' },
      { icon: 'fa-map-marker-alt', title: 'Địa chỉ', content: '2 Orchard Turn, #05-03 ION Orchard\nSingapore 238801' },
      { icon: 'fa-comments', title: 'Mạng xã hội', social: true },
    ],
    contactSubjectOptions: [
      { value: '', label: 'Chọn chủ đề' },
      { value: 'general', label: 'Hỏi chung' },
      { value: 'investment', label: 'Đầu tư' },
      { value: 'technical', label: 'Hỗ trợ kỹ thuật' },
      { value: 'partnership', label: 'Đối tác' },
      { value: 'media', label: 'Truyền thông' },
      { value: 'other', label: 'Khác' },
    ],
    contactThankYou: 'Cảm ơn tin nhắn của bạn. Chúng tôi sẽ phản hồi trong 24 giờ.',
    contactName: 'Họ tên',
    contactNamePlaceholder: 'Nhập họ tên',
    contactEmail: 'Email',
    contactSubject: 'Chủ đề',
    contactMessage: 'Nội dung tin nhắn',
    contactMessagePlaceholder: 'Mô tả câu hỏi hoặc yêu cầu của bạn...',
    contactSend: 'Gửi tin nhắn',
    // Marketplace page
    marketplacePageTitle: 'Sàn ngựa đua',
    marketplacePageSubtitle: 'Khám phá tài sản ngựa đua cao cấp và bắt đầu hành trình đầu tư',
    breadcrumbHome: 'Trang chủ',
    whyEquineRwa: {
      ...content.whyEquineRwa,
      title: 'Tại sao Equine RWA định nghĩa lại quyền sở hữu tài sản',
      titleEn: 'Tại sao Equine RWA định nghĩa lại quyền sở hữu tài sản',
      summary: 'Equine RWA kết nối tài sản thực với minh bạch on-chain mà không hy sinh tính xác thực, quản trị hay nhận thức rủi ro.',
      blocks: blocksVi,
    },
    assetIntegrity: {
      ...content.assetIntegrity,
      title: 'Uy tín tài sản và tính toàn vẹn cấu trúc',
      items: assetIntegrityItemsVi,
    },
    legalArchitecture: {
      ...content.legalArchitecture,
      title: 'Kiến trúc pháp lý minh bạch',
      titleEn: 'Kiến trúc pháp lý minh bạch',
      steps: legalStepsVi,
      paragraphZh: legalParagraphVi,
    },
    howToGetStarted: {
      ...content.howToGetStarted,
      titleZh: 'Bắt đầu như thế nào',
      steps: howToStepsVi,
    },
    marketplace: {
      ...content.marketplace,
      titleRest: 'Sàn Equine RWA NFT',
      subtitle: 'Bộ sưu tập ngựa đua số hạng nhất',
      buyButton: 'Mua ngay',
      statLabels: { speed: 'Tốc độ', stamina: 'Sức bền', power: 'Sức mạnh' },
    },
    nftData: nftDataVi,
    footer: {
      ...content.footer,
      description: 'Nền tảng số hóa tài sản ngựa đua toàn cầu. Mọi người đều có thể sở hữu ngựa đua nhà vô địch.',
      tagline: 'Mang lại minh bạch và tiếp cận quyền sở hữu ngựa đua thông qua công nghệ blockchain.',
      taglineZh: 'Từ đồng cỏ đến on-chain, mỗi con ngựa đều có linh hồn số',
      socialTitle: 'Mạng xã hội',
      copyright: '© 2026 Equine RWA. Đã đăng ký bản quyền.',
      riskDisclaimerZh:
        'Tuyên bố miễn trừ rủi ro: Tham gia Equine RWA liên quan đến đặc tính tài sản thế giới thực. Mọi lợi nhuận dựa trên kết quả đua và vận hành tài sản thực tế, không cấu thành lợi nhuận cố định hoặc được bảo đảm.',
    },
  },
}

export function getContent(locale: Locale): typeof content {
  if (locale === 'zh') return content
  const t = translations[locale]
  return { ...content, ...t } as typeof content
}

/** DApp 入口 */
export const DAPP_URL =
  import.meta.env.VITE_DAPP_URL || 'https://dapp.equinerwa.com'

/** 马匹市场 API 基础地址（落地页拉取马匹列表/详情，无则使用静态数据） */
export const MARKETPLACE_API_BASE =
  (import.meta.env.VITE_API_URL || '').replace(/\/$/, '') || ''
